// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AbandonFinanceRefundAttemptData, AbandonFinanceRefundAttemptErrors, AbandonFinanceRefundAttemptResponses, AcknowledgeChannelEventsData, AcknowledgeChannelEventsErrors, AcknowledgeChannelEventsResponses, ActivateApartmentChannelData, ActivateApartmentChannelErrors, ActivateApartmentChannelResponses, AirbnbConnectionCallbackData, AirbnbConnectionCallbackErrors, AirbnbConnectionCallbackResponses, AssignUserRoleData, AssignUserRoleErrors, AssignUserRoleResponses, AttachFinanceRefundData, AttachFinanceRefundErrors, AttachFinanceRefundResponses, BulkSetAvailabilityData, BulkSetAvailabilityErrors, BulkSetAvailabilityResponses, BulkSetRestrictionsData, BulkSetRestrictionsErrors, BulkSetRestrictionsResponses, CancelBookingData, CancelBookingErrors, CancelBookingResponses, CancelHoldData, CancelHoldErrors, CancelHoldResponses, CancelScheduledMessageData, CancelScheduledMessageErrors, CancelScheduledMessageResponses, ChangeBookingCheckoutData, ChangeBookingCheckoutErrors, ChangeBookingCheckoutResponses, CloseFinancePeriodData, CloseFinancePeriodErrors, CloseFinancePeriodResponses, CloseThreadData, CloseThreadErrors, CloseThreadResponses, CreateAirbnbConnectionLinkData, CreateAirbnbConnectionLinkErrors, CreateAirbnbConnectionLinkResponses, CreateApartmentData, CreateApartmentErrors, CreateApartmentResponses, CreateAutomationRuleData, CreateAutomationRuleErrors, CreateAutomationRuleResponses, CreateBookingData, CreateBookingErrors, CreateBookingPaymentScheduleEntryData, CreateBookingPaymentScheduleEntryErrors, CreateBookingPaymentScheduleEntryResponses, CreateBookingResponses, CreateChannelConnectionData, CreateChannelConnectionErrors, CreateChannelConnectionResponses, CreateFinanceAccountData, CreateFinanceAccountErrors, CreateFinanceAccountResponses, CreateFinanceBankCheckData, CreateFinanceBankCheckErrors, CreateFinanceBankCheckResponses, CreateFinanceCategoryData, CreateFinanceCategoryErrors, CreateFinanceCategoryResponses, CreateFinanceCounterpartyData, CreateFinanceCounterpartyErrors, CreateFinanceCounterpartyResponses, CreateFinanceEnvelopeData, CreateFinanceEnvelopeErrors, CreateFinanceEnvelopeResponses, CreateFinanceExpectedData, CreateFinanceExpectedErrors, CreateFinanceExpectedResponses, CreateFinanceMovementData, CreateFinanceMovementErrors, CreateFinanceMovementResponses, CreateFinanceRuleData, CreateFinanceRuleErrors, CreateFinanceRuleResponses, CreateFinanceSubmissionData, CreateFinanceSubmissionErrors, CreateFinanceSubmissionResponses, CreateFinanceTransferData, CreateFinanceTransferErrors, CreateFinanceTransferResponses, CreateGuestContactChannelData, CreateGuestContactChannelErrors, CreateGuestContactChannelResponses, CreateHoldData, CreateHoldErrors, CreateHoldResponses, CreatePricingStrategyData, CreatePricingStrategyErrors, CreatePricingStrategyResponses, CreateTemplateData, CreateTemplateErrors, CreateTemplateResponses, CreateUserInviteData, CreateUserInviteErrors, CreateUserInviteResponses, DeleteApartmentData, DeleteApartmentErrors, DeleteApartmentPhotoData, DeleteApartmentPhotoErrors, DeleteApartmentPhotoResponses, DeleteApartmentResponses, DeleteAutomationRuleData, DeleteAutomationRuleErrors, DeleteAutomationRuleResponses, DeleteChannelConnectionData, DeleteChannelConnectionErrors, DeleteChannelConnectionResponses, DeleteGuestContactChannelData, DeleteGuestContactChannelErrors, DeleteGuestContactChannelResponses, DeletePricingStrategyData, DeletePricingStrategyErrors, DeletePricingStrategyResponses, DeleteRuleOverrideData, DeleteRuleOverrideErrors, DeleteRuleOverrideResponses, DeleteTemplateData, DeleteTemplateErrors, DeleteTemplateResponses, DisableApartmentChannelData, DisableApartmentChannelErrors, DisableApartmentChannelResponses, GetApartmentContentData, GetApartmentContentErrors, GetApartmentContentResponses, GetApartmentData, GetApartmentDebugData, GetApartmentDebugErrors, GetApartmentDebugResponses, GetApartmentErrors, GetApartmentPricingData, GetApartmentPricingErrors, GetApartmentPricingResponses, GetApartmentResponses, GetAriCalendarData, GetAriCalendarErrors, GetAriCalendarResponses, GetAutomationRuleData, GetAutomationRuleErrors, GetAutomationRuleResponses, GetBookingComMappingDetailsData, GetBookingComMappingDetailsErrors, GetBookingComMappingDetailsResponses, GetBookingData, GetBookingErrors, GetBookingPaymentScheduleData, GetBookingPaymentScheduleErrors, GetBookingPaymentScheduleResponses, GetBookingResponses, GetChannelConnectionData, GetChannelConnectionErrors, GetChannelConnectionResponses, GetFinanceAttachmentDownloadUrlData, GetFinanceAttachmentDownloadUrlErrors, GetFinanceAttachmentDownloadUrlResponses, GetFinanceExpectedData, GetFinanceExpectedErrors, GetFinanceExpectedResponses, GetFinanceMovementData, GetFinanceMovementErrors, GetFinanceMovementResponses, GetFinancePeriodData, GetFinancePeriodErrors, GetFinancePeriodPreviewData, GetFinancePeriodPreviewErrors, GetFinancePeriodPreviewResponses, GetFinancePeriodResponses, GetFinanceRuleData, GetFinanceRuleErrors, GetFinanceRuleResponses, GetFinanceSettingsData, GetFinanceSettingsErrors, GetFinanceSettingsResponses, GetFinanceSubmissionRefsData, GetFinanceSubmissionRefsErrors, GetFinanceSubmissionRefsResponses, GetGuestConversationsData, GetGuestConversationsErrors, GetGuestConversationsResponses, GetGuestData, GetGuestErrors, GetGuestResponses, GetHoldData, GetHoldErrors, GetHoldResponses, GetPricingStrategyData, GetPricingStrategyErrors, GetPricingStrategyResponses, GetTemplateData, GetTemplateErrors, GetTemplateResponses, GetThreadData, GetThreadErrors, GetThreadResponses, GetUserData, GetUserErrors, GetUserResponses, GrantUserPermissionData, GrantUserPermissionErrors, GrantUserPermissionResponses, HealthzData, HealthzErrors, HealthzResponses, ImpersonateUserData, ImpersonateUserErrors, ImpersonateUserResponses, IssueFinanceAttachmentUploadUrlData, IssueFinanceAttachmentUploadUrlErrors, IssueFinanceAttachmentUploadUrlResponses, IssuePhotoUploadUrlData, IssuePhotoUploadUrlErrors, IssuePhotoUploadUrlResponses, LinkBookingGuestData, LinkBookingGuestErrors, LinkBookingGuestResponses, ListAirbnbConnectionListingsData, ListAirbnbConnectionListingsErrors, ListAirbnbConnectionListingsResponses, ListApartmentChannelEventsAllData, ListApartmentChannelEventsAllErrors, ListApartmentChannelEventsAllResponses, ListApartmentChannelEventsData, ListApartmentChannelEventsErrors, ListApartmentChannelEventsResponses, ListApartmentChannelsData, ListApartmentChannelsErrors, ListApartmentChannelsResponses, ListApartmentPhotosData, ListApartmentPhotosErrors, ListApartmentPhotosResponses, ListApartmentsData, ListApartmentsErrors, ListApartmentsResponses, ListAutomationRulesData, ListAutomationRulesErrors, ListAutomationRulesResponses, ListAvailabilityData, ListAvailabilityErrors, ListAvailabilityResponses, ListBookingAutomationMessagesData, ListBookingAutomationMessagesErrors, ListBookingAutomationMessagesResponses, ListBookingsData, ListBookingsErrors, ListBookingsResponses, ListChannelConnectionsData, ListChannelConnectionsErrors, ListChannelConnectionsResponses, ListFinanceAccountsData, ListFinanceAccountsErrors, ListFinanceAccountsResponses, ListFinanceBalancesData, ListFinanceBalancesErrors, ListFinanceBalancesResponses, ListFinanceBankChecksData, ListFinanceBankChecksErrors, ListFinanceBankChecksResponses, ListFinanceCategoriesData, ListFinanceCategoriesErrors, ListFinanceCategoriesResponses, ListFinanceCounterpartiesData, ListFinanceCounterpartiesErrors, ListFinanceCounterpartiesResponses, ListFinanceEnvelopeMovesData, ListFinanceEnvelopeMovesErrors, ListFinanceEnvelopeMovesResponses, ListFinanceEnvelopesData, ListFinanceEnvelopesErrors, ListFinanceEnvelopesResponses, ListFinanceExpectedData, ListFinanceExpectedErrors, ListFinanceExpectedResponses, ListFinanceFxRatesData, ListFinanceFxRatesErrors, ListFinanceFxRatesResponses, ListFinanceMovementsData, ListFinanceMovementsErrors, ListFinanceMovementsResponses, ListFinanceOpeningBalancesData, ListFinanceOpeningBalancesErrors, ListFinanceOpeningBalancesResponses, ListFinancePeriodsData, ListFinancePeriodsErrors, ListFinancePeriodsResponses, ListFinanceProviderEventsData, ListFinanceProviderEventsErrors, ListFinanceProviderEventsResponses, ListFinanceQueueData, ListFinanceQueueErrors, ListFinanceQueueResponses, ListFinanceRefundsData, ListFinanceRefundsErrors, ListFinanceRefundsResponses, ListFinanceRulesData, ListFinanceRulesErrors, ListFinanceRulesResponses, ListGuestBookingsData, ListGuestBookingsErrors, ListGuestBookingsResponses, ListGuestContactChannelsData, ListGuestContactChannelsErrors, ListGuestContactChannelsResponses, ListGuestsData, ListGuestsErrors, ListGuestsResponses, ListHoldsData, ListHoldsErrors, ListHoldsResponses, ListMyFinanceSubmissionsData, ListMyFinanceSubmissionsErrors, ListMyFinanceSubmissionsResponses, ListPermissionsData, ListPermissionsErrors, ListPermissionsResponses, ListPricingStrategiesData, ListPricingStrategiesErrors, ListPricingStrategiesResponses, ListRatePlansData, ListRatePlansErrors, ListRatePlansResponses, ListRestrictionsData, ListRestrictionsErrors, ListRestrictionsResponses, ListRolesData, ListRolesErrors, ListRolesResponses, ListRuleOverridesData, ListRuleOverridesErrors, ListRuleOverridesResponses, ListScheduledMessagesData, ListScheduledMessagesErrors, ListScheduledMessagesResponses, ListTemplatesData, ListTemplatesErrors, ListTemplatesResponses, ListThreadsData, ListThreadsErrors, ListThreadsResponses, ListUserInvitesData, ListUserInvitesErrors, ListUserInvitesResponses, ListUsersData, ListUsersErrors, ListUsersResponses, MarkThreadNoReplyData, MarkThreadNoReplyErrors, MarkThreadNoReplyResponses, MarkThreadReadData, MarkThreadReadErrors, MarkThreadReadResponses, MatchFinanceRefundAttemptData, MatchFinanceRefundAttemptErrors, MatchFinanceRefundAttemptResponses, MeData, MeErrors, MeResponses, MergeGuestData, MergeGuestErrors, MergeGuestResponses, MoveFinanceEnvelopeData, MoveFinanceEnvelopeErrors, MoveFinanceEnvelopeResponses, MoveFinanceExpectedData, MoveFinanceExpectedErrors, MoveFinanceExpectedResponses, PreviewFinanceSettleData, PreviewFinanceSettleErrors, PreviewFinanceSettleResponses, PreviewPricingData, PreviewPricingErrors, PreviewPricingResponses, PutApartmentContentData, PutApartmentContentErrors, PutApartmentContentResponses, PutRuleOverrideData, PutRuleOverrideErrors, PutRuleOverrideResponses, QuoteBookingData, QuoteBookingErrors, QuoteBookingResponses, RebuildFinanceRuleData, RebuildFinanceRuleErrors, RebuildFinanceRuleResponses, RecomputeFinanceFxData, RecomputeFinanceFxErrors, RecomputeFinanceFxResponses, RegisterApartmentPhotoData, RegisterApartmentPhotoErrors, RegisterApartmentPhotoResponses, RegisterFinanceAttachmentData, RegisterFinanceAttachmentErrors, RegisterFinanceAttachmentResponses, ReleaseRestrictionOverridesData, ReleaseRestrictionOverridesErrors, ReleaseRestrictionOverridesResponses, ReopenFinancePeriodData, ReopenFinancePeriodErrors, ReopenFinancePeriodResponses, ReorderApartmentPhotosData, ReorderApartmentPhotosErrors, ReorderApartmentPhotosResponses, ReplyToThreadData, ReplyToThreadErrors, ReplyToThreadResponses, ResendUserInviteData, ResendUserInviteErrors, ResendUserInviteResponses, ResolveFinanceProviderPaymentData, ResolveFinanceProviderPaymentErrors, ResolveFinanceProviderPaymentResponses, ResolveFinanceProviderRefundData, ResolveFinanceProviderRefundErrors, ResolveFinanceProviderRefundResponses, RetryScheduledMessageData, RetryScheduledMessageErrors, RetryScheduledMessageResponses, ReverseFinanceEnvelopeMoveData, ReverseFinanceEnvelopeMoveErrors, ReverseFinanceEnvelopeMoveResponses, ReverseFinanceMovementData, ReverseFinanceMovementErrors, ReverseFinanceMovementResponses, RevokeUserInviteData, RevokeUserInviteErrors, RevokeUserInviteResponses, RevokeUserPermissionData, RevokeUserPermissionErrors, RevokeUserPermissionResponses, RevokeUserRoleData, RevokeUserRoleErrors, RevokeUserRoleResponses, SendBookingMessageData, SendBookingMessageErrors, SendBookingMessageResponses, SendFinanceSubmissionData, SendFinanceSubmissionErrors, SendFinanceSubmissionResponses, SendGuestMessageData, SendGuestMessageErrors, SendGuestMessageResponses, SetApartmentChannelPriceAdjustmentData, SetApartmentChannelPriceAdjustmentErrors, SetApartmentChannelPriceAdjustmentResponses, SetApartmentPricingData, SetApartmentPricingErrors, SetApartmentPricingResponses, SetChannelConnectionActiveData, SetChannelConnectionActiveErrors, SetChannelConnectionActiveResponses, SetFinanceFxRateData, SetFinanceFxRateErrors, SetFinanceFxRateResponses, SetFinanceOpeningBalanceData, SetFinanceOpeningBalanceErrors, SetFinanceOpeningBalanceResponses, SettleFinanceBatchData, SettleFinanceBatchErrors, SettleFinanceBatchResponses, SettleFinanceExpectedData, SettleFinanceExpectedErrors, SettleFinanceExpectedResponses, SettleFinanceProviderPaymentData, SettleFinanceProviderPaymentErrors, SettleFinanceProviderPaymentResponses, SettleFinanceProviderRefundData, SettleFinanceProviderRefundErrors, SettleFinanceProviderRefundResponses, SettleFinanceScheduleEntryData, SettleFinanceScheduleEntryErrors, SettleFinanceScheduleEntryResponses, SetUserStatusData, SetUserStatusErrors, SetUserStatusResponses, SkipFinanceExpectedData, SkipFinanceExpectedErrors, SkipFinanceExpectedResponses, SplitFinanceExpectedData, SplitFinanceExpectedErrors, SplitFinanceExpectedResponses, SplitFinanceRefundData, SplitFinanceRefundErrors, SplitFinanceRefundResponses, StopImpersonationData, StopImpersonationErrors, StopImpersonationResponses, SuggestFinanceMovementEnvelopeData, SuggestFinanceMovementEnvelopeErrors, SuggestFinanceMovementEnvelopeResponses, SyncApartmentChannelData, SyncApartmentChannelErrors, SyncApartmentChannelResponses, TestChannelConnectionData, TestChannelConnectionErrors, TestChannelConnectionResponses, TriggerFullSyncData, TriggerFullSyncErrors, TriggerFullSyncResponses, UnresolveFinanceProviderPaymentData, UnresolveFinanceProviderPaymentErrors, UnresolveFinanceProviderPaymentResponses, UnresolveFinanceProviderRefundData, UnresolveFinanceProviderRefundErrors, UnresolveFinanceProviderRefundResponses, UpdateAirbnbConnectionSettingsData, UpdateAirbnbConnectionSettingsErrors, UpdateAirbnbConnectionSettingsResponses, UpdateApartmentMetadataData, UpdateApartmentMetadataErrors, UpdateApartmentMetadataResponses, UpdateApartmentPhotoData, UpdateApartmentPhotoErrors, UpdateApartmentPhotoResponses, UpdateAutomationRuleData, UpdateAutomationRuleErrors, UpdateAutomationRuleResponses, UpdateBookingPaymentScheduleEntryData, UpdateBookingPaymentScheduleEntryErrors, UpdateBookingPaymentScheduleEntryResponses, UpdateBookingServiceInfoData, UpdateBookingServiceInfoErrors, UpdateBookingServiceInfoResponses, UpdateFinanceAccountData, UpdateFinanceAccountErrors, UpdateFinanceAccountResponses, UpdateFinanceCategoryData, UpdateFinanceCategoryErrors, UpdateFinanceCategoryResponses, UpdateFinanceCounterpartyData, UpdateFinanceCounterpartyErrors, UpdateFinanceCounterpartyResponses, UpdateFinanceEnvelopeData, UpdateFinanceEnvelopeErrors, UpdateFinanceEnvelopeResponses, UpdateFinanceRuleData, UpdateFinanceRuleErrors, UpdateFinanceRuleResponses, UpdateFinanceSettingsData, UpdateFinanceSettingsErrors, UpdateFinanceSettingsResponses, UpdateFinanceSubmissionData, UpdateFinanceSubmissionErrors, UpdateFinanceSubmissionResponses, UpdateGuestContactChannelData, UpdateGuestContactChannelErrors, UpdateGuestContactChannelResponses, UpdateGuestProfileData, UpdateGuestProfileErrors, UpdateGuestProfileResponses, UpdatePricingStrategyData, UpdatePricingStrategyErrors, UpdatePricingStrategyResponses, UpdateTemplateData, UpdateTemplateErrors, UpdateTemplateResponses, UpsertApartmentChannelData, UpsertApartmentChannelErrors, UpsertApartmentChannelResponses, WriteOffFinanceRefundData, WriteOffFinanceRefundErrors, WriteOffFinanceRefundResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health check
 */
export const healthz = <ThrowOnError extends boolean = false>(options?: Options<HealthzData, ThrowOnError>) => (options?.client ?? client).get<HealthzResponses, HealthzErrors, ThrowOnError>({ url: '/healthz', ...options });

/**
 * Current authenticated user
 */
export const me = <ThrowOnError extends boolean = false>(options?: Options<MeData, ThrowOnError>) => (options?.client ?? client).get<MeResponses, MeErrors, ThrowOnError>({ url: '/api/v1/me', ...options });

/**
 * Bulk-set availability for multiple apartments and dates
 */
export const bulkSetAvailability = <ThrowOnError extends boolean = false>(options: Options<BulkSetAvailabilityData, ThrowOnError>) => (options.client ?? client).post<BulkSetAvailabilityResponses, BulkSetAvailabilityErrors, ThrowOnError>({
    url: '/api/v1/ari/availability:bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-set rates and restrictions for multiple rate plans and dates
 */
export const bulkSetRestrictions = <ThrowOnError extends boolean = false>(options: Options<BulkSetRestrictionsData, ThrowOnError>) => (options.client ?? client).post<BulkSetRestrictionsResponses, BulkSetRestrictionsErrors, ThrowOnError>({
    url: '/api/v1/ari/restrictions:bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release operator-pinned restriction/rate fields back to the pricing engine
 *
 * Clears operator pins (rate_calendar.overridden_fields, ADR-038 price
 * override) for a date range on a rate plan — "return to strategy". When
 * `fields` is empty or omitted, ALL pinned fields are released for every
 * date in the range. Releasing a pin does not itself change any
 * rate/restriction value or push anything to Channex (CLAUDE.md rule 1
 * does not apply — no ARI value changes, so there is nothing to write to
 * the transactional outbox); it only un-pins the field so the next
 * pricing recompute (enqueued by this call when something was actually
 * released) can compute and push the strategy's value.
 *
 */
export const releaseRestrictionOverrides = <ThrowOnError extends boolean = false>(options: Options<ReleaseRestrictionOverridesData, ThrowOnError>) => (options.client ?? client).post<ReleaseRestrictionOverridesResponses, ReleaseRestrictionOverridesErrors, ThrowOnError>({
    url: '/api/v1/ari/restrictions:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List availability for apartments over a date window
 */
export const listAvailability = <ThrowOnError extends boolean = false>(options: Options<ListAvailabilityData, ThrowOnError>) => (options.client ?? client).get<ListAvailabilityResponses, ListAvailabilityErrors, ThrowOnError>({
    querySerializer: { parameters: { apartment_ids: { array: { explode: false } } } },
    url: '/api/v1/ari/availability',
    ...options
});

/**
 * List rates and restrictions for rate plans over a date window
 */
export const listRestrictions = <ThrowOnError extends boolean = false>(options: Options<ListRestrictionsData, ThrowOnError>) => (options.client ?? client).get<ListRestrictionsResponses, ListRestrictionsErrors, ThrowOnError>({
    querySerializer: { parameters: { rate_plan_ids: { array: { explode: false } } } },
    url: '/api/v1/ari/restrictions',
    ...options
});

/**
 * Combined calendar window — availability, restrictions, bookings, holds
 *
 * Single scoped payload for the operator calendar grid: availability +
 * nightly restrictions + overlapping bookings + overlapping
 * pending-payment holds for the requested apartments and window. The
 * window is capped at 90 days per fetch (the grid pages by scrolling).
 * Apartment-scoping is applied at this handler via the ABAC policy.
 *
 */
export const getAriCalendar = <ThrowOnError extends boolean = false>(options: Options<GetAriCalendarData, ThrowOnError>) => (options.client ?? client).get<GetAriCalendarResponses, GetAriCalendarErrors, ThrowOnError>({
    querySerializer: { parameters: { apartment_ids: { array: { explode: false } } } },
    url: '/api/v1/ari/calendar',
    ...options
});

/**
 * Trigger a full ARI sync into the outbox
 *
 * Reads the availability and restriction calendars for the given window
 * and re-emits every row through the transactional outbox so Channex
 * receives a fresh snapshot. Use only on go-live and recovery — not for
 * periodic use (see CLAUDE.md rule 3).
 *
 */
export const triggerFullSync = <ThrowOnError extends boolean = false>(options?: Options<TriggerFullSyncData, ThrowOnError>) => (options?.client ?? client).post<TriggerFullSyncResponses, TriggerFullSyncErrors, ThrowOnError>({
    url: '/api/v1/ari/full-sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List all apartments
 */
export const listApartments = <ThrowOnError extends boolean = false>(options?: Options<ListApartmentsData, ThrowOnError>) => (options?.client ?? client).get<ListApartmentsResponses, ListApartmentsErrors, ThrowOnError>({ url: '/api/v1/apartments', ...options });

/**
 * Create an apartment (provisions Channex property + room_type + rate_plan)
 *
 * Inserts the local rows in 'provisioning' state in one transaction,
 * then sequentially calls Channex POST /properties, /room_types,
 * /rate_plans. Returns the activated apartment on success.
 *
 * If a Channex call fails mid-flow the rows stay in provisioning;
 * the worker reconciler finishes them on its next tick (see
 * ADR-030 1n and worker apartmentReconciler).
 *
 * Returns 503 if the server was started without CHANNEX_BASE_URL or
 * PMS_KMS_KEY — both are required to provision new apartments.
 *
 */
export const createApartment = <ThrowOnError extends boolean = false>(options: Options<CreateApartmentData, ThrowOnError>) => (options.client ?? client).post<CreateApartmentResponses, CreateApartmentErrors, ThrowOnError>({
    url: '/api/v1/apartments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete an apartment
 *
 * Sets is_active=false on the apartment. Idempotent: calling delete on
 * an already-inactive apartment also returns 204. Returns 404 (not 403)
 * when the caller has no scope on the apartment, matching GetApartment's
 * anti-enumeration policy.
 *
 * Phase-1 limitation: the matching Channex property is NOT deactivated.
 * Operator must disconnect OTA channels in the Channex dashboard
 * themselves. See ADR-030.
 *
 */
export const deleteApartment = <ThrowOnError extends boolean = false>(options: Options<DeleteApartmentData, ThrowOnError>) => (options.client ?? client).delete<DeleteApartmentResponses, DeleteApartmentErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}', ...options });

/**
 * Get a single apartment with full metadata
 */
export const getApartment = <ThrowOnError extends boolean = false>(options: Options<GetApartmentData, ThrowOnError>) => (options.client ?? client).get<GetApartmentResponses, GetApartmentErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}', ...options });

/**
 * Update editable apartment metadata
 *
 * Patches the apartment-local metadata fields. Address, title,
 * occupancy and other Channex-synced fields are NOT editable via
 * this endpoint — they need a parallel push to Channex which lands
 * in a separate slice.
 *
 * Optional fields semantics:
 * - field absent → no change
 * - field present with non-null value → set
 * - field present with null → clear (set to NULL in DB)
 *
 */
export const updateApartmentMetadata = <ThrowOnError extends boolean = false>(options: Options<UpdateApartmentMetadataData, ThrowOnError>) => (options.client ?? client).patch<UpdateApartmentMetadataResponses, UpdateApartmentMetadataErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue a presigned R2 PUT URL for direct browser upload
 *
 * Generates a fresh photo_id and returns a presigned PUT URL the
 * client uploads bytes to directly. After upload, the client calls
 * POST /apartments/{id}/photos with the same photo_id to register
 * the row in the DB.
 *
 * URL expiry is 15 minutes. Returns 503 if the server was started
 * without R2 credentials.
 *
 */
export const issuePhotoUploadUrl = <ThrowOnError extends boolean = false>(options: Options<IssuePhotoUploadUrlData, ThrowOnError>) => (options.client ?? client).post<IssuePhotoUploadUrlResponses, IssuePhotoUploadUrlErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/photos/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List photos for an apartment
 */
export const listApartmentPhotos = <ThrowOnError extends boolean = false>(options: Options<ListApartmentPhotosData, ThrowOnError>) => (options.client ?? client).get<ListApartmentPhotosResponses, ListApartmentPhotosErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/photos', ...options });

/**
 * Register a photo after R2 upload completes
 *
 * Persists the photo row in the DB. photo_id must match the one
 * returned by /upload-url. R2 key must follow the
 * "apartments/{apartment_id}/{photo_id}.<ext>" namespace — the
 * server rejects anything else to keep namespaces clean.
 *
 */
export const registerApartmentPhoto = <ThrowOnError extends boolean = false>(options: Options<RegisterApartmentPhotoData, ThrowOnError>) => (options.client ?? client).post<RegisterApartmentPhotoResponses, RegisterApartmentPhotoErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/photos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder photos in a single transaction
 *
 * Applies a batch of sort_order updates atomically. Order entries
 * whose photo_id doesn't belong to this apartment or is soft-deleted
 * are silently no-op'd (the underlying UPDATE filters them out).
 *
 */
export const reorderApartmentPhotos = <ThrowOnError extends boolean = false>(options: Options<ReorderApartmentPhotosData, ThrowOnError>) => (options.client ?? client).patch<ReorderApartmentPhotosResponses, ReorderApartmentPhotosErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/photos/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete a photo (idempotent)
 */
export const deleteApartmentPhoto = <ThrowOnError extends boolean = false>(options: Options<DeleteApartmentPhotoData, ThrowOnError>) => (options.client ?? client).delete<DeleteApartmentPhotoResponses, DeleteApartmentPhotoErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/photos/{photo_id}', ...options });

/**
 * Update alt text and cover flag for a single photo
 *
 * Promoting a photo to cover demotes the previous cover in the same
 * transaction so the apartment_photos_one_cover_per_apartment
 * partial UNIQUE index stays satisfied.
 *
 */
export const updateApartmentPhoto = <ThrowOnError extends boolean = false>(options: Options<UpdateApartmentPhotoData, ThrowOnError>) => (options.client ?? client).patch<UpdateApartmentPhotoResponses, UpdateApartmentPhotoErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/photos/{photo_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List OTA channel mappings for an apartment
 */
export const listApartmentChannels = <ThrowOnError extends boolean = false>(options: Options<ListApartmentChannelsData, ThrowOnError>) => (options.client ?? client).get<ListApartmentChannelsResponses, ListApartmentChannelsErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channels', ...options });

/**
 * Disable an OTA channel mapping
 *
 * Sets enabled=false and stamps disabled_at + disabled_by. Idempotent:
 * a second call against an already-disabled mapping also returns 204.
 *
 */
export const disableApartmentChannel = <ThrowOnError extends boolean = false>(options: Options<DisableApartmentChannelData, ThrowOnError>) => (options.client ?? client).delete<DisableApartmentChannelResponses, DisableApartmentChannelErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channels/{provider}', ...options });

/**
 * Create or replace an OTA channel mapping
 *
 * Idempotent upsert keyed on (apartment_id, provider). The row is
 * unconditionally enabled and any prior disabled_at/disabled_by audit
 * fields are cleared — the CHECK constraint forbids partial state.
 *
 */
export const upsertApartmentChannel = <ThrowOnError extends boolean = false>(options: Options<UpsertApartmentChannelData, ThrowOnError>) => (options.client ?? client).put<UpsertApartmentChannelResponses, UpsertApartmentChannelErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/channels/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate an OTA channel for an apartment
 *
 * Sets is_active=true on the Channex channel and flips the connection
 * status to "active". The mapping must already exist (call upsertApartmentChannel
 * first to create it with the correct room/rate codes).
 *
 */
export const activateApartmentChannel = <ThrowOnError extends boolean = false>(options: Options<ActivateApartmentChannelData, ThrowOnError>) => (options.client ?? client).post<ActivateApartmentChannelResponses, ActivateApartmentChannelErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channels/{provider}/activate', ...options });

/**
 * Sync an apartment channel mapping with Channex
 *
 * Calls GetChannel on Channex, reconciles is_active/status, and updates
 * the mapping sync_status to "synced" or "error".
 *
 */
export const syncApartmentChannel = <ThrowOnError extends boolean = false>(options: Options<SyncApartmentChannelData, ThrowOnError>) => (options.client ?? client).post<SyncApartmentChannelResponses, SyncApartmentChannelErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channels/{provider}/sync', ...options });

/**
 * Set a price adjustment for an apartment channel
 *
 * Persists a price adjustment in basis points for the given
 * (apartment, provider) mapping. The adjustment is applied at ARI
 * push time by the rate composer. No Channex call is made.
 *
 */
export const setApartmentChannelPriceAdjustment = <ThrowOnError extends boolean = false>(options: Options<SetApartmentChannelPriceAdjustmentData, ThrowOnError>) => (options.client ?? client).put<SetApartmentChannelPriceAdjustmentResponses, SetApartmentChannelPriceAdjustmentErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/channels/{provider}/price-adjustment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List sync events for an apartment channel
 *
 * Returns recent channel_sync_events rows for the given
 * (apartment, provider) pair, newest first.
 *
 */
export const listApartmentChannelEvents = <ThrowOnError extends boolean = false>(options: Options<ListApartmentChannelEventsData, ThrowOnError>) => (options.client ?? client).get<ListApartmentChannelEventsResponses, ListApartmentChannelEventsErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channels/{provider}/events', ...options });

/**
 * List every sync event for an apartment, attributed or not
 *
 * Returns every channel_sync_events row for the apartment — attributed
 * and unattributed alike, newest first, capped by `limit`. Unlike
 * GET .../channels/{provider}/events, which filters to one provider,
 * this is the only read path that surfaces events with no resolved
 * provider (`provider` is null): those rows count toward
 * active_error_total but never appear under any provider's channel
 * card, so this endpoint is what makes them visible and, via
 * POST .../channel-events:acknowledge, actionable.
 *
 */
export const listApartmentChannelEventsAll = <ThrowOnError extends boolean = false>(options: Options<ListApartmentChannelEventsAllData, ThrowOnError>) => (options.client ?? client).get<ListApartmentChannelEventsAllResponses, ListApartmentChannelEventsAllErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/channel-events', ...options });

/**
 * Acknowledge channel sync error events for an apartment
 *
 * Marks the given channel_sync_events rows acknowledged by the calling
 * operator, so they stop masking newer errors in active_error_total /
 * active_error_count. Apartment-scoped rather than provider-scoped:
 * unattributed events (no resolved provider) have no provider path to
 * reach them through. Idempotent — acknowledging an already-acknowledged
 * id is a success and keeps its original acknowledged_at/acknowledged_by.
 * 404s (rather than partially applying) if any event_id does not belong
 * to this apartment.
 *
 * The response is the same apartment-wide, most-recent-first, capped
 * page that GET .../events returns — not a complete list of every event
 * for the apartment, and not provider-filtered (so unattributed rows are
 * included). A client showing that page may write this response
 * straight into it without a second round trip. An acknowledged id that
 * falls outside the page boundary (older than the cap) still gets
 * acknowledged in the database, but will not appear in this response —
 * do not treat this response as an authoritative full replacement of
 * everything the client knows about the apartment's events.
 *
 */
export const acknowledgeChannelEvents = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeChannelEventsData, ThrowOnError>) => (options.client ?? client).post<AcknowledgeChannelEventsResponses, AcknowledgeChannelEventsErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/channel-events:acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator diagnostics panel for an apartment
 *
 * Returns Channex identifiers, ARI outbox backlog, channel sync
 * events, and raw webhook audit rows for one apartment. Two gates,
 * in order: apartments.read first — a denial answers 404, like
 * every other apartment endpoint, so it never confirms an
 * apartment exists to a caller who cannot see it at all. Only
 * once that passes is debug.read checked — no role grants it by
 * default, so it is a standalone per-user grant, not merely an
 * extra restriction layered on top of apartment read access — and
 * a denial there answers 403 (not 404), because by that point
 * apartment read access has already been proved, so hiding the
 * panel's existence buys nothing.
 *
 */
export const getApartmentDebug = <ThrowOnError extends boolean = false>(options: Options<GetApartmentDebugData, ThrowOnError>) => (options.client ?? client).get<GetApartmentDebugResponses, GetApartmentDebugErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/debug', ...options });

/**
 * List all OTA channel connections
 *
 * Returns all channel_connections rows, optionally filtered by provider.
 *
 */
export const listChannelConnections = <ThrowOnError extends boolean = false>(options?: Options<ListChannelConnectionsData, ThrowOnError>) => (options?.client ?? client).get<ListChannelConnectionsResponses, ListChannelConnectionsErrors, ThrowOnError>({ url: '/api/v1/channel-connections', ...options });

/**
 * Create a new OTA channel connection
 *
 * Creates a channel connection. For booking_com, tests the hotel_id
 * with Channex before persisting. For airbnb, use createAirbnbConnectionLink
 * instead. For booking_engine, creates a direct connection without Channex.
 *
 */
export const createChannelConnection = <ThrowOnError extends boolean = false>(options: Options<CreateChannelConnectionData, ThrowOnError>) => (options.client ?? client).post<CreateChannelConnectionResponses, CreateChannelConnectionErrors, ThrowOnError>({
    url: '/api/v1/channel-connections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a channel connection
 *
 * Deletes a channel_connections row. The connection must not have any
 * active mappings; disable all apartment channel mappings first.
 *
 */
export const deleteChannelConnection = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelConnectionData, ThrowOnError>) => (options.client ?? client).delete<DeleteChannelConnectionResponses, DeleteChannelConnectionErrors, ThrowOnError>({ url: '/api/v1/channel-connections/{id}', ...options });

/**
 * Get a channel connection by ID
 */
export const getChannelConnection = <ThrowOnError extends boolean = false>(options: Options<GetChannelConnectionData, ThrowOnError>) => (options.client ?? client).get<GetChannelConnectionResponses, GetChannelConnectionErrors, ThrowOnError>({ url: '/api/v1/channel-connections/{id}', ...options });

/**
 * Test a channel connection against Channex
 *
 * Calls Channex test_connection for the given connection, updates
 * last_tested_at and last_error, and returns whether the test passed.
 *
 */
export const testChannelConnection = <ThrowOnError extends boolean = false>(options: Options<TestChannelConnectionData, ThrowOnError>) => (options.client ?? client).post<TestChannelConnectionResponses, TestChannelConnectionErrors, ThrowOnError>({ url: '/api/v1/channel-connections/{id}/test', ...options });

/**
 * Update Airbnb channel settings on a connected channel
 *
 * Read-merge-writes the Airbnb channel-level settings onto the live Channex
 * channel WITHOUT re-doing OAuth: the OAuth tokens and the channel's current
 * is_active are preserved. Only valid for an OAuth (Airbnb) connection that
 * has completed the OAuth flow (has a channex_channel_id).
 *
 */
export const updateAirbnbConnectionSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateAirbnbConnectionSettingsData, ThrowOnError>) => (options.client ?? client).put<UpdateAirbnbConnectionSettingsResponses, UpdateAirbnbConnectionSettingsErrors, ThrowOnError>({
    url: '/api/v1/channel-connections/{id}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate or deactivate a channel connection
 *
 * Flips the connection's Channex channel is_active and mirrors it to the
 * connection status. Connection-scoped (the channel-accounts page acts on
 * connections): the shared Airbnb channel is activated once for all its
 * mapped apartments. Requires a mapped channel (channex_channel_id).
 *
 */
export const setChannelConnectionActive = <ThrowOnError extends boolean = false>(options: Options<SetChannelConnectionActiveData, ThrowOnError>) => (options.client ?? client).put<SetChannelConnectionActiveResponses, SetChannelConnectionActiveErrors, ThrowOnError>({
    url: '/api/v1/channel-connections/{id}/active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Booking.com room/rate tree for a connection
 *
 * Fetches the OTA room/rate mapping tree from Channex for a
 * Booking.com connection. Used to populate the room/rate dropdowns
 * in the MapApartment wizard step.
 *
 */
export const getBookingComMappingDetails = <ThrowOnError extends boolean = false>(options: Options<GetBookingComMappingDetailsData, ThrowOnError>) => (options.client ?? client).get<GetBookingComMappingDetailsResponses, GetBookingComMappingDetailsErrors, ThrowOnError>({ url: '/api/v1/channel-connections/{id}/mapping-details', ...options });

/**
 * List Airbnb listings accessible via a connection
 *
 * Returns the Airbnb listings reachable via the given connection's
 * Channex channel. The connection must already be active
 * (channex_channel_id set; HandleAirbnbCallback called).
 *
 */
export const listAirbnbConnectionListings = <ThrowOnError extends boolean = false>(options: Options<ListAirbnbConnectionListingsData, ThrowOnError>) => (options.client ?? client).get<ListAirbnbConnectionListingsResponses, ListAirbnbConnectionListingsErrors, ThrowOnError>({ url: '/api/v1/channel-connections/{id}/airbnb-listings', ...options });

/**
 * Begin Airbnb OAuth connection flow
 *
 * Generates a one-time auth_token, inserts a pending_auth connection
 * row, calls AirbnbConnectionLink on Channex, and returns the
 * (connection_id, redirect_url) pair. The operator is redirected to
 * redirect_url to complete the OAuth flow. On completion, Channex
 * redirects back to the airbnbConnectionCallback endpoint.
 *
 */
export const createAirbnbConnectionLink = <ThrowOnError extends boolean = false>(options: Options<CreateAirbnbConnectionLinkData, ThrowOnError>) => (options.client ?? client).post<CreateAirbnbConnectionLinkResponses, CreateAirbnbConnectionLinkErrors, ThrowOnError>({
    url: '/api/v1/channel-connections/airbnb/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Airbnb OAuth callback endpoint
 *
 * Receives the OAuth redirect from Channex/Airbnb after the operator
 * grants access. Looks up the pending connection by auth_token, stores
 * the channex_channel_id, moves the connection from pending_auth to
 * inactive (Channex creates the channel inactive; the operator activates
 * it after mapping), then redirects the browser to the ops console
 * channel detail page.
 *
 */
export const airbnbConnectionCallback = <ThrowOnError extends boolean = false>(options: Options<AirbnbConnectionCallbackData, ThrowOnError>) => (options.client ?? client).get<AirbnbConnectionCallbackResponses, AirbnbConnectionCallbackErrors, ThrowOnError>({ url: '/api/v1/channel-connections/airbnb/callback', ...options });

/**
 * Get the descriptive content sections for an apartment
 *
 * Returns the net-new descriptive content (1:1 with the apartment). An
 * apartment whose content has never been authored returns all-null text
 * fields with all OTA-sync flags false (the row is created lazily on first
 * write).
 *
 */
export const getApartmentContent = <ThrowOnError extends boolean = false>(options: Options<GetApartmentContentData, ThrowOnError>) => (options.client ?? client).get<GetApartmentContentResponses, GetApartmentContentErrors, ThrowOnError>({ url: '/api/v1/apartments/{id}/content', ...options });

/**
 * Replace the descriptive content sections for an apartment
 *
 * Full replace of the 1:1 content row. Every field is written verbatim:
 * a null (or omitted) text field clears that section. The eight
 * descriptive sections each carry an ota_sync flag; wifi credentials do
 * not (they are operational data, never OTA listing copy).
 *
 */
export const putApartmentContent = <ThrowOnError extends boolean = false>(options: Options<PutApartmentContentData, ThrowOnError>) => (options.client ?? client).put<PutApartmentContentResponses, PutApartmentContentErrors, ThrowOnError>({
    url: '/api/v1/apartments/{id}/content',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List bookings with optional filters
 */
export const listBookings = <ThrowOnError extends boolean = false>(options?: Options<ListBookingsData, ThrowOnError>) => (options?.client ?? client).get<ListBookingsResponses, ListBookingsErrors, ThrowOnError>({
    querySerializer: { parameters: {
            status: { array: { explode: false } },
            apartment_ids: { array: { explode: false } },
            source: { array: { explode: false } }
        } },
    url: '/api/v1/bookings',
    ...options
});

/**
 * Create a manual booking
 *
 * Creates a confirmed manual (walk-in / phone) booking for an apartment.
 * The booking is inserted directly as confirmed; availability is recomputed
 * and pushed to Channex via the ARI service (ADR-034, CLAUDE.md rule #8).
 * Requires bookings.write permission.
 *
 */
export const createBooking = <ThrowOnError extends boolean = false>(options: Options<CreateBookingData, ThrowOnError>) => (options.client ?? client).post<CreateBookingResponses, CreateBookingErrors, ThrowOnError>({
    url: '/api/v1/bookings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Price a stay for a manual booking
 *
 * Server-authoritative price for an apartment + date range, summed from the
 * pushed rate_calendar rates and checked against availability/restrictions —
 * the same computation the guest booking engine uses. Read-only; never
 * creates anything. Returns available=false + a reason when the stay cannot
 * be booked (the operator can still create a manual booking with a manual
 * total and allow_overbook). Requires bookings.write permission.
 *
 */
export const quoteBooking = <ThrowOnError extends boolean = false>(options: Options<QuoteBookingData, ThrowOnError>) => (options.client ?? client).post<QuoteBookingResponses, QuoteBookingErrors, ThrowOnError>({
    url: '/api/v1/bookings:quote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single booking with revision timeline
 */
export const getBooking = <ThrowOnError extends boolean = false>(options: Options<GetBookingData, ThrowOnError>) => (options.client ?? client).get<GetBookingResponses, GetBookingErrors, ThrowOnError>({ url: '/api/v1/bookings/{id}', ...options });

/**
 * Link a booking to a canonical guest
 *
 * Manual "Link to guest" for an auto-match miss (ADR-031). Sets
 * bookings.guest_id. Requires bookings.write. 404 if the booking or the
 * target guest does not exist.
 *
 */
export const linkBookingGuest = <ThrowOnError extends boolean = false>(options: Options<LinkBookingGuestData, ThrowOnError>) => (options.client ?? client).post<LinkBookingGuestResponses, LinkBookingGuestErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/link-guest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit a booking's operational service info
 *
 * Full-replace of the operational record (expected check-in/out, service
 * requests, internal notes). Requires bookings.write (operational roles).
 * Omitted/null fields clear; the row is created lazily on first edit.
 *
 */
export const updateBookingServiceInfo = <ThrowOnError extends boolean = false>(options: Options<UpdateBookingServiceInfoData, ThrowOnError>) => (options.client ?? client).patch<UpdateBookingServiceInfoResponses, UpdateBookingServiceInfoErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/service-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A booking's expected-payment schedule (cashflow expectation layer)
 *
 * The booking's payment schedule (ADR-033): what we expect to receive and
 * when, plus which entries are reconciled against received payments and a
 * received/outstanding summary. Requires bookings.read. 404 on a missing
 * booking or a scope-denied apartment (no oracle).
 *
 */
export const getBookingPaymentSchedule = <ThrowOnError extends boolean = false>(options: Options<GetBookingPaymentScheduleData, ThrowOnError>) => (options.client ?? client).get<GetBookingPaymentScheduleResponses, GetBookingPaymentScheduleErrors, ThrowOnError>({ url: '/api/v1/bookings/{id}/payment-schedule', ...options });

/**
 * Add a human-entered row to a booking's payment schedule
 *
 * Operator-entered payment-schedule row (ADR-033 §5, OH-124 slice 2).
 * currency is always the booking's own and is not settable; seq is
 * assigned server-side (max+1); the row is created origin=operator,
 * status=expected. Requires payments.schedule_write. 404 on a missing
 * booking or a scope-denied apartment (no oracle) — same shape as GET,
 * never a 403 that would reveal the booking exists.
 *
 */
export const createBookingPaymentScheduleEntry = <ThrowOnError extends boolean = false>(options: Options<CreateBookingPaymentScheduleEntryData, ThrowOnError>) => (options.client ?? client).post<CreateBookingPaymentScheduleEntryResponses, CreateBookingPaymentScheduleEntryErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/payment-schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit a booking's payment-schedule row
 *
 * Partial edit (ADR-033 §5, OH-124 slice 2): only the fields present in
 * the request change. Sets origin=operator — including a row born
 * origin=system, which is how the operator takes over an obligation
 * the converger was computing; the converger never touches that row
 * again afterwards. One exception (OH-183 item 8): a row that already
 * carries observed money (money_observed) keeps its origin when the
 * request changes none of amount, method and status — a date-only
 * correction does not hand the row over (the converger would add a
 * duplicate system row beside it). status=received also stamps received_at
 * — to the given received_at when the caller supplies one (the operator
 * recording a bank transfer that landed on a real, possibly past, date;
 * rejected if it is in the future), else to now, once (a later PATCH
 * that omits received_at leaves an already-stamped row alone).
 * received_at is rejected on a row that is not becoming/staying
 * received. There is no DELETE: the lifecycle IS the status enum
 * (ADR-027 exception recorded in ADR-033); "delete" is status=cancelled.
 * Requires payments.schedule_write. 404 on a missing booking, a missing
 * entry, or a scope-denied apartment (no oracle).
 *
 * OH-166 §10.1/§13.2: once income_side_enabled is on, this endpoint
 * refuses to bypass the finance block. 409 `Problem.code` values:
 * `use_finance_reverse` (the row is received — reverse the finance
 * movement instead of PATCHing it away), `money_observed` (the row
 * carries observed money — a charged VCC, a refund obligation, or a
 * finance-block link — and the request would void it, change its
 * amount, or change its method), `period_closed` (the new expected_at
 * falls in a closed month). 422 `use_finance_settle`: the request
 * would mark the row received directly — confirm the receipt in the
 * finance block (settle) instead. 422 `use_refund_obligation`
 * (OH-166 task 19 fix round 1): the request changes method to
 * 'refund' — a refund row is created by the refund flow
 * (payment_refunds), never entered or converted to directly, same
 * guard as POST. 409 `conflict` (OH-183 item 13): the row is waived
 * or cancelled and the request changes its amount or method — a
 * closed row is history. All six are gated on income_side_enabled —
 * with the flag off, this endpoint behaves exactly as before (OH-124
 * slice 2).
 *
 */
export const updateBookingPaymentScheduleEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateBookingPaymentScheduleEntryData, ThrowOnError>) => (options.client ?? client).patch<UpdateBookingPaymentScheduleEntryResponses, UpdateBookingPaymentScheduleEntryErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/payment-schedule/{entry_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a direct/manual booking (ARI-only; deterministic)
 *
 * Cancels a booking WE own (channex_booking_id IS NULL) — an ARI-only
 * direct or operator-manual booking (ADR-034). Rejects OTA/Channex
 * bookings (channex_booking_id set) with 409: those are cancelled in
 * Channex and flow back via the booking_cancellation webhook. On success
 * it flips the status to cancelled, recomputes availability for
 * [checkin, checkout) (restoring the freed nights via one batched
 * availability push), voids outstanding 'expected' payment-schedule
 * entries, and — when a captured payment exists for the booking's hold —
 * issues a provider refund. Idempotent: an already-cancelled booking
 * returns 200 (no refund) and re-runs the availability recompute.
 * Requires bookings.cancel.
 *
 */
export const cancelBooking = <ThrowOnError extends boolean = false>(options: Options<CancelBookingData, ThrowOnError>) => (options.client ?? client).post<CancelBookingResponses, CancelBookingErrors, ThrowOnError>({ url: '/api/v1/bookings/{id}/cancel', ...options });

/**
 * Change the checkout date of a direct/manual booking
 *
 * Moves the checkout of a booking WE own (channex_booking_id IS NULL,
 * source manual|direct, status confirmed) — extension or early departure,
 * past dates allowed — and sets the new total the operator agreed.
 * One transaction: booking row (optimistic on expected_version),
 * expected checkout time, availability (ARI outbox), and the
 * booking.stay_dates_changed event that re-aligns scheduled messages.
 * Money already received is not touched: the operator edits the payment
 * schedule. Requires bookings.write.
 *
 * 401 unauthenticated; 404 unknown booking or an apartment outside the
 * caller's scope (no existence oracle — a denial and an unknown id
 * return the identical body). 409 `Problem.code` values: `no_availability`
 * (the added nights overlap another booking or active hold and
 * allow_overbook was not set), `stale` (expected_version no longer
 * matches), `not_editable` (not a confirmed direct/manual booking).
 *
 */
export const changeBookingCheckout = <ThrowOnError extends boolean = false>(options: Options<ChangeBookingCheckoutData, ThrowOnError>) => (options.client ?? client).post<ChangeBookingCheckoutResponses, ChangeBookingCheckoutErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/change-checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a message to a booking's guest
 *
 * Finds or creates a thread for the given booking and sends a message to
 * the guest. OTA bookings route via the OTA channel; direct/manual bookings
 * route via email. Requires messages.send permission.
 *
 */
export const sendBookingMessage = <ThrowOnError extends boolean = false>(options: Options<SendBookingMessageData, ThrowOnError>) => (options.client ?? client).post<SendBookingMessageResponses, SendBookingMessageErrors, ThrowOnError>({
    url: '/api/v1/bookings/{id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List holds (admin)
 *
 * Returns holds for troubleshooting — current and recently expired.
 * Requires holds.read permission. Scoped users see only their assigned apartments.
 *
 */
export const listHolds = <ThrowOnError extends boolean = false>(options?: Options<ListHoldsData, ThrowOnError>) => (options?.client ?? client).get<ListHoldsResponses, ListHoldsErrors, ThrowOnError>({ url: '/api/v1/holds', ...options });

/**
 * Create a direct-booking hold
 *
 * Reserves availability locally for the given apartment and date range.
 * The hold does NOT notify Channex — it only prevents our own booking
 * engine from overselling (CLAUDE.md rule 9). The hold expires after
 * 15 minutes if payment is not captured.
 * Requires holds.write permission (listings_manager or super_admin).
 *
 */
export const createHold = <ThrowOnError extends boolean = false>(options: Options<CreateHoldData, ThrowOnError>) => (options.client ?? client).post<CreateHoldResponses, CreateHoldErrors, ThrowOnError>({
    url: '/api/v1/holds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a hold by ID
 */
export const getHold = <ThrowOnError extends boolean = false>(options: Options<GetHoldData, ThrowOnError>) => (options.client ?? client).get<GetHoldResponses, GetHoldErrors, ThrowOnError>({ url: '/api/v1/holds/{id}', ...options });

/**
 * Cancel a hold (admin action)
 *
 * Manually cancel a pending_payment hold.
 * Requires holds.write permission.
 *
 */
export const cancelHold = <ThrowOnError extends boolean = false>(options: Options<CancelHoldData, ThrowOnError>) => (options.client ?? client).post<CancelHoldResponses, CancelHoldErrors, ThrowOnError>({ url: '/api/v1/holds/{id}/cancel', ...options });

/**
 * List pending (unconsumed) invites
 */
export const listUserInvites = <ThrowOnError extends boolean = false>(options?: Options<ListUserInvitesData, ThrowOnError>) => (options?.client ?? client).get<ListUserInvitesResponses, ListUserInvitesErrors, ThrowOnError>({ url: '/api/v1/users/invites', ...options });

/**
 * Create a user invite
 */
export const createUserInvite = <ThrowOnError extends boolean = false>(options: Options<CreateUserInviteData, ThrowOnError>) => (options.client ?? client).post<CreateUserInviteResponses, CreateUserInviteErrors, ThrowOnError>({
    url: '/api/v1/users/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List operator users
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({ url: '/api/v1/users', ...options });

/**
 * Get a single user with role assignments
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({ url: '/api/v1/users/{id}', ...options });

/**
 * List the RBAC role catalogue
 */
export const listRoles = <ThrowOnError extends boolean = false>(options?: Options<ListRolesData, ThrowOnError>) => (options?.client ?? client).get<ListRolesResponses, ListRolesErrors, ThrowOnError>({ url: '/api/v1/roles', ...options });

/**
 * List the canonical permission (action) catalogue
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => (options?.client ?? client).get<ListPermissionsResponses, ListPermissionsErrors, ThrowOnError>({ url: '/api/v1/permissions', ...options });

/**
 * Assign (or re-scope) a role for a user
 */
export const assignUserRole = <ThrowOnError extends boolean = false>(options: Options<AssignUserRoleData, ThrowOnError>) => (options.client ?? client).post<AssignUserRoleResponses, AssignUserRoleErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a role from a user
 */
export const revokeUserRole = <ThrowOnError extends boolean = false>(options: Options<RevokeUserRoleData, ThrowOnError>) => (options.client ?? client).delete<RevokeUserRoleResponses, RevokeUserRoleErrors, ThrowOnError>({ url: '/api/v1/users/{id}/roles/{role}', ...options });

/**
 * Activate or deactivate a user
 */
export const setUserStatus = <ThrowOnError extends boolean = false>(options: Options<SetUserStatusData, ThrowOnError>) => (options.client ?? client).patch<SetUserStatusResponses, SetUserStatusErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start impersonating a user (become the user, 60-minute time-box)
 */
export const impersonateUser = <ThrowOnError extends boolean = false>(options: Options<ImpersonateUserData, ThrowOnError>) => (options.client ?? client).post<ImpersonateUserResponses, ImpersonateUserErrors, ThrowOnError>({ url: '/api/v1/users/{id}/impersonate', ...options });

/**
 * Stop impersonating (idempotent)
 */
export const stopImpersonation = <ThrowOnError extends boolean = false>(options?: Options<StopImpersonationData, ThrowOnError>) => (options?.client ?? client).delete<StopImpersonationResponses, StopImpersonationErrors, ThrowOnError>({ url: '/api/v1/me/impersonation', ...options });

/**
 * Regenerate an invite token and resend the invite email
 */
export const resendUserInvite = <ThrowOnError extends boolean = false>(options: Options<ResendUserInviteData, ThrowOnError>) => (options.client ?? client).post<ResendUserInviteResponses, ResendUserInviteErrors, ThrowOnError>({ url: '/api/v1/users/invites/{inviteId}/resend', ...options });

/**
 * Revoke (delete) a pending invite
 */
export const revokeUserInvite = <ThrowOnError extends boolean = false>(options: Options<RevokeUserInviteData, ThrowOnError>) => (options.client ?? client).delete<RevokeUserInviteResponses, RevokeUserInviteErrors, ThrowOnError>({ url: '/api/v1/users/invites/{inviteId}', ...options });

/**
 * Grant a single permission directly to a user
 */
export const grantUserPermission = <ThrowOnError extends boolean = false>(options: Options<GrantUserPermissionData, ThrowOnError>) => (options.client ?? client).post<GrantUserPermissionResponses, GrantUserPermissionErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/grants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a direct permission grant from a user
 */
export const revokeUserPermission = <ThrowOnError extends boolean = false>(options: Options<RevokeUserPermissionData, ThrowOnError>) => (options.client ?? client).delete<RevokeUserPermissionResponses, RevokeUserPermissionErrors, ThrowOnError>({ url: '/api/v1/users/{id}/grants/{action}', ...options });

/**
 * List message threads
 *
 * Returns a paged list of message threads. Requires threads.read permission.
 * Phase 1 simplification: all threads are visible to any operator with threads.read
 * (global scope, no per-apartment filtering at query time).
 *
 */
export const listThreads = <ThrowOnError extends boolean = false>(options?: Options<ListThreadsData, ThrowOnError>) => (options?.client ?? client).get<ListThreadsResponses, ListThreadsErrors, ThrowOnError>({ url: '/api/v1/threads', ...options });

/**
 * Get a thread with its messages
 */
export const getThread = <ThrowOnError extends boolean = false>(options: Options<GetThreadData, ThrowOnError>) => (options.client ?? client).get<GetThreadResponses, GetThreadErrors, ThrowOnError>({ url: '/api/v1/threads/{id}', ...options });

/**
 * Send a reply message to a thread
 *
 * Creates an outgoing message (sender=property) and enqueues a Channex
 * message.send outbox event. Requires messages.send permission.
 *
 */
export const replyToThread = <ThrowOnError extends boolean = false>(options: Options<ReplyToThreadData, ThrowOnError>) => (options.client ?? client).post<ReplyToThreadResponses, ReplyToThreadErrors, ThrowOnError>({
    url: '/api/v1/threads/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close a message thread
 *
 * Marks the thread as closed and enqueues a Channex thread.close outbox
 * event. Returns 409 if the thread is already closed.
 * Requires threads.close permission.
 *
 */
export const closeThread = <ThrowOnError extends boolean = false>(options: Options<CloseThreadData, ThrowOnError>) => (options.client ?? client).post<CloseThreadResponses, CloseThreadErrors, ThrowOnError>({ url: '/api/v1/threads/{id}/close', ...options });

/**
 * Mark a thread as no-reply-needed
 *
 * Enqueues a Channex thread.no_reply_needed outbox event.
 * Requires threads.no_reply permission.
 *
 */
export const markThreadNoReply = <ThrowOnError extends boolean = false>(options: Options<MarkThreadNoReplyData, ThrowOnError>) => (options.client ?? client).post<MarkThreadNoReplyResponses, MarkThreadNoReplyErrors, ThrowOnError>({ url: '/api/v1/threads/{id}/no-reply', ...options });

/**
 * Mark a thread as read
 *
 * Sets last_read_at = now() on the thread, resetting the unread message
 * count to zero. Requires threads.read permission.
 *
 */
export const markThreadRead = <ThrowOnError extends boolean = false>(options: Options<MarkThreadReadData, ThrowOnError>) => (options.client ?? client).post<MarkThreadReadResponses, MarkThreadReadErrors, ThrowOnError>({ url: '/api/v1/threads/{id}/read', ...options });

/**
 * List message templates
 */
export const listTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListTemplatesData, ThrowOnError>) => (options?.client ?? client).get<ListTemplatesResponses, ListTemplatesErrors, ThrowOnError>({ url: '/api/v1/templates', ...options });

/**
 * Create a message template
 */
export const createTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    url: '/api/v1/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a message template
 */
export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({ url: '/api/v1/templates/{id}', ...options });

/**
 * Get a message template by ID
 */
export const getTemplate = <ThrowOnError extends boolean = false>(options: Options<GetTemplateData, ThrowOnError>) => (options.client ?? client).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({ url: '/api/v1/templates/{id}', ...options });

/**
 * Partially update a message template
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateData, ThrowOnError>) => (options.client ?? client).patch<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError>({
    url: '/api/v1/templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a booking's automation messages (debug)
 *
 * Returns every scheduled automation message for the booking (all
 * statuses, scheduled_for ASC), enriched with rule/template names and a
 * body preview. For sent rows the preview is the ACTUALLY delivered body;
 * for every other status it is a live render of the current template with
 * the frozen render variables (exactly what the send path would produce),
 * falling back to the frozen body when live rendering is not possible.
 * Requires automation.read.
 *
 */
export const listBookingAutomationMessages = <ThrowOnError extends boolean = false>(options: Options<ListBookingAutomationMessagesData, ThrowOnError>) => (options.client ?? client).get<ListBookingAutomationMessagesResponses, ListBookingAutomationMessagesErrors, ThrowOnError>({ url: '/api/v1/bookings/{id}/automation-messages', ...options });

/**
 * List automation rules
 */
export const listAutomationRules = <ThrowOnError extends boolean = false>(options?: Options<ListAutomationRulesData, ThrowOnError>) => (options?.client ?? client).get<ListAutomationRulesResponses, ListAutomationRulesErrors, ThrowOnError>({ url: '/api/v1/automation-rules', ...options });

/**
 * Create an automation rule
 */
export const createAutomationRule = <ThrowOnError extends boolean = false>(options: Options<CreateAutomationRuleData, ThrowOnError>) => (options.client ?? client).post<CreateAutomationRuleResponses, CreateAutomationRuleErrors, ThrowOnError>({
    url: '/api/v1/automation-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an automation rule
 */
export const deleteAutomationRule = <ThrowOnError extends boolean = false>(options: Options<DeleteAutomationRuleData, ThrowOnError>) => (options.client ?? client).delete<DeleteAutomationRuleResponses, DeleteAutomationRuleErrors, ThrowOnError>({ url: '/api/v1/automation-rules/{id}', ...options });

/**
 * Get an automation rule by ID
 */
export const getAutomationRule = <ThrowOnError extends boolean = false>(options: Options<GetAutomationRuleData, ThrowOnError>) => (options.client ?? client).get<GetAutomationRuleResponses, GetAutomationRuleErrors, ThrowOnError>({ url: '/api/v1/automation-rules/{id}', ...options });

/**
 * Partially update an automation rule
 */
export const updateAutomationRule = <ThrowOnError extends boolean = false>(options: Options<UpdateAutomationRuleData, ThrowOnError>) => (options.client ?? client).patch<UpdateAutomationRuleResponses, UpdateAutomationRuleErrors, ThrowOnError>({
    url: '/api/v1/automation-rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List per-apartment overrides for an automation rule
 */
export const listRuleOverrides = <ThrowOnError extends boolean = false>(options: Options<ListRuleOverridesData, ThrowOnError>) => (options.client ?? client).get<ListRuleOverridesResponses, ListRuleOverridesErrors, ThrowOnError>({ url: '/api/v1/automation-rules/{id}/overrides', ...options });

/**
 * Remove a per-apartment override for an automation rule
 */
export const deleteRuleOverride = <ThrowOnError extends boolean = false>(options: Options<DeleteRuleOverrideData, ThrowOnError>) => (options.client ?? client).delete<DeleteRuleOverrideResponses, DeleteRuleOverrideErrors, ThrowOnError>({ url: '/api/v1/automation-rules/{id}/overrides/{apartment_id}', ...options });

/**
 * Upsert a per-apartment override for an automation rule
 */
export const putRuleOverride = <ThrowOnError extends boolean = false>(options: Options<PutRuleOverrideData, ThrowOnError>) => (options.client ?? client).put<PutRuleOverrideResponses, PutRuleOverrideErrors, ThrowOnError>({
    url: '/api/v1/automation-rules/{id}/overrides/{apartment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List rate plans
 *
 * Returns all active rate plans, optionally filtered by apartment IDs.
 */
export const listRatePlans = <ThrowOnError extends boolean = false>(options?: Options<ListRatePlansData, ThrowOnError>) => (options?.client ?? client).get<ListRatePlansResponses, ListRatePlansErrors, ThrowOnError>({
    querySerializer: { parameters: { apartment_ids: { array: { explode: false } } } },
    url: '/api/v1/rate-plans',
    ...options
});

/**
 * List scheduled messages
 *
 * Returns a paginated list of scheduled messages, ordered by scheduled_for DESC.
 */
export const listScheduledMessages = <ThrowOnError extends boolean = false>(options?: Options<ListScheduledMessagesData, ThrowOnError>) => (options?.client ?? client).get<ListScheduledMessagesResponses, ListScheduledMessagesErrors, ThrowOnError>({ url: '/api/v1/automation/scheduled', ...options });

/**
 * Cancel a pending scheduled message
 *
 * Cancels the row only while it is still pending. A row the worker has
 * already leased, or that has resolved (sent/failed/cancelled), is left
 * untouched and reported as a 409 conflict. Requires automation.write.
 *
 */
export const cancelScheduledMessage = <ThrowOnError extends boolean = false>(options: Options<CancelScheduledMessageData, ThrowOnError>) => (options.client ?? client).post<CancelScheduledMessageResponses, CancelScheduledMessageErrors, ThrowOnError>({ url: '/api/v1/automation/scheduled/{id}/cancel', ...options });

/**
 * Retry a failed or cancelled scheduled message
 *
 * Returns a failed/cancelled row to pending with a fresh attempt budget.
 * An overdue schedule fires on the next worker tick; a future cancelled
 * schedule is restored as-is. 409 when the row is not failed/cancelled,
 * or when re-materialization already created an active replacement row
 * for the same rule and booking. Requires automation.write.
 *
 */
export const retryScheduledMessage = <ThrowOnError extends boolean = false>(options: Options<RetryScheduledMessageData, ThrowOnError>) => (options.client ?? client).post<RetryScheduledMessageResponses, RetryScheduledMessageErrors, ThrowOnError>({ url: '/api/v1/automation/scheduled/{id}/retry', ...options });

/**
 * Search guests
 *
 * Returns guests whose full_name, email, or phone contains the query
 * string (ILIKE). Soft-deleted and merged guests are excluded.
 * Requires guests.read permission (global — no apartment scoping).
 *
 */
export const listGuests = <ThrowOnError extends boolean = false>(options?: Options<ListGuestsData, ThrowOnError>) => (options?.client ?? client).get<ListGuestsResponses, ListGuestsErrors, ThrowOnError>({ url: '/api/v1/guests', ...options });

/**
 * Get a single guest
 */
export const getGuest = <ThrowOnError extends boolean = false>(options: Options<GetGuestData, ThrowOnError>) => (options.client ?? client).get<GetGuestResponses, GetGuestErrors, ThrowOnError>({ url: '/api/v1/guests/{id}', ...options });

/**
 * Update a guest profile
 *
 * Updates the guest's editable profile fields (full_name, email, phone,
 * language, notes). Omit a field to leave it unchanged. Send explicit
 * null for a nullable field (email, phone, language, notes) to clear it.
 * Requires guests.write permission (global).
 * No optimistic locking — last-write-wins (guests have no version column).
 *
 */
export const updateGuestProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateGuestProfileData, ThrowOnError>) => (options.client ?? client).patch<UpdateGuestProfileResponses, UpdateGuestProfileErrors, ThrowOnError>({
    url: '/api/v1/guests/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merge a duplicate guest into a canonical guest
 *
 * **Direction (unmistakable):**
 * - `{id}` (path parameter) — the **SOURCE**: the duplicate guest being
 * absorbed. After a successful merge this row will have `merged_into_id`
 * set to `into_id` and will no longer appear in search results.
 * - `into_id` (request body) — the **TARGET / SURVIVOR**: the canonical
 * guest that keeps its identity, name, and future bookings.
 *
 * All bookings previously referencing the source are re-associated with
 * the canonical guest. Any previously-merged guest that pointed at the
 * source is also updated to point at the canonical (chain flattening —
 * no dangling merge chains). The source row is **never hard-deleted**.
 *
 * The operation is **idempotent**: calling it twice with the same
 * source → into pair succeeds on both calls.
 *
 * Requires `guests.write` permission (global).
 *
 */
export const mergeGuest = <ThrowOnError extends boolean = false>(options: Options<MergeGuestData, ThrowOnError>) => (options.client ?? client).post<MergeGuestResponses, MergeGuestErrors, ThrowOnError>({
    url: '/api/v1/guests/{id}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List bookings for a guest
 *
 * Returns booking projections for all bookings associated with the guest,
 * ordered by checkin_date DESC. Requires guests.read permission (global).
 *
 */
export const listGuestBookings = <ThrowOnError extends boolean = false>(options: Options<ListGuestBookingsData, ThrowOnError>) => (options.client ?? client).get<ListGuestBookingsResponses, ListGuestBookingsErrors, ThrowOnError>({ url: '/api/v1/guests/{id}/bookings', ...options });

/**
 * List message threads across all of a guest's bookings
 *
 * Virtual aggregator: returns the message threads attached to any booking
 * associated with the guest, across all of their stays. The UI deep-links
 * each thread to the existing inbox thread view. Requires guests.read
 * permission (global). Returns an empty list when the guest has no
 * bookings (and therefore no threads).
 *
 */
export const getGuestConversations = <ThrowOnError extends boolean = false>(options: Options<GetGuestConversationsData, ThrowOnError>) => (options.client ?? client).get<GetGuestConversationsResponses, GetGuestConversationsErrors, ThrowOnError>({ url: '/api/v1/guests/{id}/conversations', ...options });

/**
 * Send a message to a guest (no booking context)
 *
 * Finds or creates a guest-only thread (no booking anchor) and sends a
 * message. Routes via email by default. Requires messages.send permission.
 *
 */
export const sendGuestMessage = <ThrowOnError extends boolean = false>(options: Options<SendGuestMessageData, ThrowOnError>) => (options.client ?? client).post<SendGuestMessageResponses, SendGuestMessageErrors, ThrowOnError>({
    url: '/api/v1/guests/{id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a guest's contact channels (address book)
 *
 * Enabled channels only. Requires guests.read (global).
 */
export const listGuestContactChannels = <ThrowOnError extends boolean = false>(options: Options<ListGuestContactChannelsData, ThrowOnError>) => (options.client ?? client).get<ListGuestContactChannelsResponses, ListGuestContactChannelsErrors, ThrowOnError>({ url: '/api/v1/guests/{id}/contact-channels', ...options });

/**
 * Add a contact channel to a guest
 *
 * Requires guests.write (global). Promoting to preferred demotes the prior preferred of the same kind.
 */
export const createGuestContactChannel = <ThrowOnError extends boolean = false>(options: Options<CreateGuestContactChannelData, ThrowOnError>) => (options.client ?? client).post<CreateGuestContactChannelResponses, CreateGuestContactChannelErrors, ThrowOnError>({
    url: '/api/v1/guests/{id}/contact-channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove (soft-delete) a guest contact channel
 *
 * Requires guests.write (global). Idempotent.
 */
export const deleteGuestContactChannel = <ThrowOnError extends boolean = false>(options: Options<DeleteGuestContactChannelData, ThrowOnError>) => (options.client ?? client).delete<DeleteGuestContactChannelResponses, DeleteGuestContactChannelErrors, ThrowOnError>({ url: '/api/v1/guests/{id}/contact-channels/{channel_id}', ...options });

/**
 * Update a guest contact channel
 *
 * Requires guests.write (global). kind and guest are immutable.
 */
export const updateGuestContactChannel = <ThrowOnError extends boolean = false>(options: Options<UpdateGuestContactChannelData, ThrowOnError>) => (options.client ?? client).patch<UpdateGuestContactChannelResponses, UpdateGuestContactChannelErrors, ThrowOnError>({
    url: '/api/v1/guests/{id}/contact-channels/{channel_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all enabled pricing strategies
 */
export const listPricingStrategies = <ThrowOnError extends boolean = false>(options?: Options<ListPricingStrategiesData, ThrowOnError>) => (options?.client ?? client).get<ListPricingStrategiesResponses, ListPricingStrategiesErrors, ThrowOnError>({ url: '/api/v1/pricing/strategies', ...options });

/**
 * Create a pricing strategy
 */
export const createPricingStrategy = <ThrowOnError extends boolean = false>(options: Options<CreatePricingStrategyData, ThrowOnError>) => (options.client ?? client).post<CreatePricingStrategyResponses, CreatePricingStrategyErrors, ThrowOnError>({
    url: '/api/v1/pricing/strategies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-disable a pricing strategy
 *
 * Soft-deletes (disables) a strategy. Returns 409 if the strategy
 * is still assigned to one or more apartments.
 *
 */
export const deletePricingStrategy = <ThrowOnError extends boolean = false>(options: Options<DeletePricingStrategyData, ThrowOnError>) => (options.client ?? client).delete<DeletePricingStrategyResponses, DeletePricingStrategyErrors, ThrowOnError>({ url: '/api/v1/pricing/strategies/{id}', ...options });

/**
 * Get a pricing strategy by ID
 */
export const getPricingStrategy = <ThrowOnError extends boolean = false>(options: Options<GetPricingStrategyData, ThrowOnError>) => (options.client ?? client).get<GetPricingStrategyResponses, GetPricingStrategyErrors, ThrowOnError>({ url: '/api/v1/pricing/strategies/{id}', ...options });

/**
 * Replace a pricing strategy (name, min_stay, rules)
 *
 * Atomically replaces all rules for the strategy. The rules array
 * is replaced transactionally (delete-all then re-insert).
 *
 */
export const updatePricingStrategy = <ThrowOnError extends boolean = false>(options: Options<UpdatePricingStrategyData, ThrowOnError>) => (options.client ?? client).put<UpdatePricingStrategyResponses, UpdatePricingStrategyErrors, ThrowOnError>({
    url: '/api/v1/pricing/strategies/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get apartment pricing settings
 */
export const getApartmentPricing = <ThrowOnError extends boolean = false>(options: Options<GetApartmentPricingData, ThrowOnError>) => (options.client ?? client).get<GetApartmentPricingResponses, GetApartmentPricingErrors, ThrowOnError>({ url: '/api/v1/apartments/{apartmentId}/pricing', ...options });

/**
 * Create or update apartment pricing settings
 */
export const setApartmentPricing = <ThrowOnError extends boolean = false>(options: Options<SetApartmentPricingData, ThrowOnError>) => (options.client ?? client).put<SetApartmentPricingResponses, SetApartmentPricingErrors, ThrowOnError>({
    url: '/api/v1/apartments/{apartmentId}/pricing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview computed pricing cells for an apartment
 *
 * Returns computed per-date rate and restriction cells for the given
 * apartment and date range. No writes. Optionally overrides the
 * assigned strategy (what-if) and/or the reference date (as_of).
 *
 * Gap-night detection requires confirmed bookings. The v1 preview
 * passes no booking intervals, so gap_night rules will not fire.
 * All other rule types (month, seasonal, day_of_week, date_specific,
 * min_nights, booking_restriction, last_minute, advanced_booking)
 * are fully computed.
 *
 */
export const previewPricing = <ThrowOnError extends boolean = false>(options: Options<PreviewPricingData, ThrowOnError>) => (options.client ?? client).post<PreviewPricingResponses, PreviewPricingErrors, ThrowOnError>({
    url: '/api/v1/pricing/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finance accounts (money containers)
 *
 * Requires finance.read. Inactive accounts are left out unless include_inactive=true.
 */
export const listFinanceAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceAccountsData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceAccountsResponses, ListFinanceAccountsErrors, ThrowOnError>({ url: '/api/v1/finance/accounts', ...options });

/**
 * Create a finance account
 *
 * Requires finance.manage. 422 validation when the name is empty, the
 * kind is unknown, the currency list is empty, or a currency is not a
 * currency internal/money knows.
 *
 */
export const createFinanceAccount = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceAccountData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceAccountResponses, CreateFinanceAccountErrors, ThrowOnError>({
    url: '/api/v1/finance/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a finance account
 *
 * Requires finance.manage. The whole account is sent, not a delta.
 * 409 conflict when a currency is dropped that still has movements, a
 * non-zero balance, or an opening balance on record (spec §5.1);
 * 422 validation for the same input rules as create. `fee_rule` absent
 * or null removes the rule (the whole account is sent).
 *
 */
export const updateFinanceAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceAccountData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceAccountResponses, UpdateFinanceAccountErrors, ThrowOnError>({
    url: '/api/v1/finance/accounts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Baseline history of one account
 *
 * Requires finance.read. Superseded baselines are included — a replaced
 * baseline is what the figure WAS, and superseded_by says so (spec §5.2).
 * 404 not_found when the account does not exist.
 *
 */
export const listFinanceOpeningBalances = <ThrowOnError extends boolean = false>(options: Options<ListFinanceOpeningBalancesData, ThrowOnError>) => (options.client ?? client).get<ListFinanceOpeningBalancesResponses, ListFinanceOpeningBalancesErrors, ThrowOnError>({ url: '/api/v1/finance/accounts/{id}/opening', ...options });

/**
 * Record an opening balance (baseline) for one account and currency
 *
 * Requires finance.manage. balance_minor is the balance at the START of
 * as_of, i.e. the bank's closing balance for the previous day (spec §5.2);
 * a live baseline on the same as_of is superseded. operation_id is the
 * client's idempotency key (spec §5.19). 404 not_found for an unknown
 * account; 409 period_closed when as_of falls in a closed month,
 * 409 operation_conflict when the key was used for a different body;
 * 422 validation and 422 account_currency when the account does not hold
 * the currency.
 *
 */
export const setFinanceOpeningBalance = <ThrowOnError extends boolean = false>(options: Options<SetFinanceOpeningBalanceData, ThrowOnError>) => (options.client ?? client).post<SetFinanceOpeningBalanceResponses, SetFinanceOpeningBalanceErrors, ThrowOnError>({
    url: '/api/v1/finance/accounts/{id}/opening',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Balance of every active account and currency on a date
 *
 * Requires finance.read. One row per active account+currency pair, read
 * inside one repeatable-read snapshot. estimated=true means the pair has
 * no baseline on or before as_of and the figure is summed from movements
 * alone (spec §5.2). as_of left out means today in the business timezone.
 * 422 validation when as_of is the zero date 0001-01-01: every baseline
 * is in its future and the whole grid would come back as plausible
 * zeroes.
 *
 */
export const listFinanceBalances = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceBalancesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceBalancesResponses, ListFinanceBalancesErrors, ThrowOnError>({ url: '/api/v1/finance/balances', ...options });

/**
 * Finance categories (P&L articles)
 *
 * Requires finance.read. Inactive categories are left out unless include_inactive=true.
 */
export const listFinanceCategories = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceCategoriesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceCategoriesResponses, ListFinanceCategoriesErrors, ThrowOnError>({ url: '/api/v1/finance/categories', ...options });

/**
 * Create a finance category
 *
 * Requires finance.manage. The category is operator-defined: is_system is
 * not settable here, only migration 0069's seed mints system categories.
 * 409 conflict when the code is already taken; 422 validation for an
 * empty name or code, an unknown kind or expense_type_default, or an
 * unknown default_account_id.
 *
 */
export const createFinanceCategory = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceCategoryData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceCategoryResponses, CreateFinanceCategoryErrors, ThrowOnError>({
    url: '/api/v1/finance/categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a finance category
 *
 * Requires finance.manage. The whole category is sent, not a delta; code
 * is immutable and is_system is never settable. 409 conflict when kind or
 * in_pnl is changed on a system category, when the category already has
 * payments, or when a category the engine resolves by code would be
 * deactivated (spec §5.4); 422 validation for the same input rules as
 * create. default_envelope_id must name an active envelope (422); one
 * the category already holds may be re-sent after it was switched off.
 * Omitting default_envelope_id keeps the category's current one;
 * an explicit null clears it.
 *
 */
export const updateFinanceCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceCategoryData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceCategoryResponses, UpdateFinanceCategoryErrors, ThrowOnError>({
    url: '/api/v1/finance/categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finance counterparties
 *
 * Requires finance.read. Inactive counterparties are left out unless include_inactive=true.
 */
export const listFinanceCounterparties = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceCounterpartiesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceCounterpartiesResponses, ListFinanceCounterpartiesErrors, ThrowOnError>({ url: '/api/v1/finance/counterparties', ...options });

/**
 * Create a finance counterparty
 *
 * Requires finance.manage. 409 conflict when a counterparty of that name
 * already exists (names are unique case-insensitively); 422 validation
 * for an empty name or an unknown kind.
 *
 */
export const createFinanceCounterparty = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceCounterpartyData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceCounterpartyResponses, CreateFinanceCounterpartyErrors, ThrowOnError>({
    url: '/api/v1/finance/counterparties',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a finance counterparty
 *
 * Requires finance.manage. The whole counterparty is sent, not a delta.
 * 409 conflict when the new name belongs to another counterparty;
 * 422 validation for an empty name or an unknown kind.
 *
 */
export const updateFinanceCounterparty = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceCounterpartyData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceCounterpartyResponses, UpdateFinanceCounterpartyErrors, ThrowOnError>({
    url: '/api/v1/finance/counterparties/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finance movements (payment headers with lines), newest first
 *
 * Requires finance.read. Reversed pairs are hidden unless
 * include_reversed=true. 400 bad_request when from is after to — the feed
 * has no rows in a reversed range and answering 200 with an empty page
 * would read as «no money in that window» rather than as a bad window.
 *
 */
export const listFinanceMovements = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceMovementsData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceMovementsResponses, ListFinanceMovementsErrors, ThrowOnError>({ url: '/api/v1/finance/movements', ...options });

/**
 * Record a direct payment (income/expense lines under one bank amount)
 *
 * Requires finance.confirm.
 * An `envelope` on an incoming payment additionally requires
 * finance.manage (403 forbidden otherwise, envelopes spec §6); on an
 * outgoing one finance.confirm is enough. 409 envelope_insufficient when
 * a spend from an envelope would take it below zero on some day
 * (envelopes spec §4);
 * 422 validation for an envelope tag that is switched off or whose
 * amount is above the payment's EUR.
 * operation_id is the client's idempotency key
 * (core spec §5.19): a repeat with the same body returns the stored
 * result with replayed=true; a different body → 409 operation_conflict.
 * 404 not_found when account_id names no account;
 * 409 period_closed when occurred_on falls in a closed month;
 * 422 unbalanced when lines do not sum to amount_minor;
 * 422 account_currency when the account does not hold the currency;
 * 422 validation for everything else, an unknown category, apartment,
 * booking or counterparty on a line included.
 *
 */
export const createFinanceMovement = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceMovementData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceMovementResponses, CreateFinanceMovementErrors, ThrowOnError>({
    url: '/api/v1/finance/movements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One movement with its lines
 *
 * Requires finance.read.
 */
export const getFinanceMovement = <ThrowOnError extends boolean = false>(options: Options<GetFinanceMovementData, ThrowOnError>) => (options.client ?? client).get<GetFinanceMovementResponses, GetFinanceMovementErrors, ThrowOnError>({ url: '/api/v1/finance/movements/{id}', ...options });

/**
 * Reverse a movement, optionally replacing it
 *
 * Requires finance.confirm. Writes a mirror header (opposite direction,
 * same account, currency, amount and EUR) and, when replacement is given,
 * the movement that should have been there instead — both under this
 * operation_id (core spec §8.6). A movement in a closed month is
 * mirrored with occurred_on = business today and correction_for_month =
 * its month.
 * 404 not_found for an unknown movement, or when a replacement names an
 * account that does not exist;
 * 409 already_reversed, 409 period_closed, 409 operation_conflict;
 * 422 validation, unbalanced or account_currency, all from the
 * replacement.
 * Additionally requires finance.manage when any envelope move of the
 * movement itself is an `in`, or when the replacement tags an incoming
 * payment (envelopes spec §6). 409 envelope_insufficient when a mirror or
 * the replacement would take an envelope below zero.
 *
 */
export const reverseFinanceMovement = <ThrowOnError extends boolean = false>(options: Options<ReverseFinanceMovementData, ThrowOnError>) => (options.client ?? client).post<ReverseFinanceMovementResponses, ReverseFinanceMovementErrors, ThrowOnError>({
    url: '/api/v1/finance/movements/{id}/reverse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suggest the envelope tag of a payment being composed
 *
 * Requires finance.confirm. Read-only (envelopes spec §8): the form's
 * current header and lines are converted to EUR at the rate the payment
 * would be created with; the envelope is the default of the first line's
 * category that has an active one; suggested_eur_minor is Σ that
 * envelope's lines in EUR, at most the header's EUR and, for an outgoing
 * payment, at most what the envelope has available from occurred_on
 * (envelopes spec §4). envelope_id null — no line's category has an
 * active default envelope. Nothing is written; the create re-checks
 * everything.
 * 422 validation, a currency without a rate on or before occurred_on included.
 *
 */
export const suggestFinanceMovementEnvelope = <ThrowOnError extends boolean = false>(options: Options<SuggestFinanceMovementEnvelopeData, ThrowOnError>) => (options.client ?? client).post<SuggestFinanceMovementEnvelopeResponses, SuggestFinanceMovementEnvelopeErrors, ThrowOnError>({
    url: '/api/v1/finance/movements/envelope-hint',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move money between two accounts (two headers under one transfer_id)
 *
 * Requires finance.confirm. Same currency on both legs: from − fee = to,
 * else 422 unbalanced. Different currencies: both legs carry their actual
 * amounts and the fee is optional (core spec §6.5). operation_id is the
 * client's idempotency key (core spec §5.19).
 * 404 not_found when either leg names an account that does not exist;
 * 409 period_closed when a leg's occurred_on falls in a closed month,
 * 409 operation_conflict when the key was used for a different body;
 * 422 validation, 422 unbalanced, 422 account_currency.
 *
 */
export const createFinanceTransfer = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceTransferData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceTransferResponses, CreateFinanceTransferErrors, ThrowOnError>({
    url: '/api/v1/finance/transfers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Envelopes with balances, and operating money
 *
 * Requires finance.read. The envelopes (the switched-off ones only with
 * include_inactive=true) with their balance as of business today;
 * operating money = Σ real accounts in EUR on business today at the
 * latest rate ≤ today − Σ every envelope on that day, a switched-off one
 * too (envelopes spec §2), flagged estimated with the currencies that
 * have a balance and no rate. With available_on, each active envelope
 * also carries available_eur_minor: the most one spend dated that day can
 * take under the no-minus rule (envelopes spec §4).
 *
 */
export const listFinanceEnvelopes = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceEnvelopesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceEnvelopesResponses, ListFinanceEnvelopesErrors, ThrowOnError>({ url: '/api/v1/finance/envelopes', ...options });

/**
 * Create a user-defined envelope
 *
 * Requires finance.manage. 409 custom_envelopes_disabled while
 * finance_settings.custom_envelopes_enabled is false (spec §3.2 p.7);
 * 409 conflict when the name (case-insensitive) is taken; 422 validation.
 *
 */
export const createFinanceEnvelope = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceEnvelopeData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceEnvelopeResponses, CreateFinanceEnvelopeErrors, ThrowOnError>({
    url: '/api/v1/finance/envelopes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename, re-note, re-sort, switch an envelope off or on
 *
 * Requires finance.manage. The whole envelope is sent. Switching off only
 * at zero balance, counted over all its moves, future-dated ones too —
 * 409 envelope_not_empty otherwise; 409 conflict on a taken name; 404
 * not_found; 422 validation. The answer carries the balance as of
 * business today, as the list does.
 *
 */
export const updateFinanceEnvelope = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceEnvelopeData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceEnvelopeResponses, UpdateFinanceEnvelopeErrors, ThrowOnError>({
    url: '/api/v1/finance/envelopes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The envelope feed
 *
 * Requires finance.read. Newest first; envelope_id narrows it to one envelope.
 */
export const listFinanceEnvelopeMoves = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceEnvelopeMovesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceEnvelopeMovesResponses, ListFinanceEnvelopeMovesErrors, ThrowOnError>({ url: '/api/v1/finance/envelope-moves', ...options });

/**
 * Allocate money to an envelope or release it to operating money
 *
 * Requires finance.manage. Allocate (in) or release to operating money
 * (out). A release is checked against the no-minus rule (envelopes spec
 * §4): 409 envelope_insufficient names the envelope and what is
 * available. Envelopes are EUR-only counters and no account is touched
 * (core spec §5.10). operation_id is the client's idempotency key (core
 * spec §5.19).
 * 409 period_closed when occurred_on falls in a closed month,
 * 409 operation_conflict when the key was used for a different body;
 * 422 validation, a switched-off envelope included.
 *
 */
export const moveFinanceEnvelope = <ThrowOnError extends boolean = false>(options: Options<MoveFinanceEnvelopeData, ThrowOnError>) => (options.client ?? client).post<MoveFinanceEnvelopeResponses, MoveFinanceEnvelopeErrors, ThrowOnError>({
    url: '/api/v1/finance/envelopes/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reverse a manual envelope move
 *
 * Requires finance.manage. Writes the mirror move — opposite direction,
 * same envelope and amount, reverses_id set. A move in a closed month is
 * mirrored with occurred_on = business today (spec §8.6).
 * 404 not_found for an unknown move;
 * 409 already_reversed, 409 period_closed, 409 operation_conflict;
 * 409 envelope_insufficient when the mirror would take the envelope
 * below zero;
 * 422 validation when the reason is empty.
 *
 */
export const reverseFinanceEnvelopeMove = <ThrowOnError extends boolean = false>(options: Options<ReverseFinanceEnvelopeMoveData, ThrowOnError>) => (options.client ?? client).post<ReverseFinanceEnvelopeMoveResponses, ReverseFinanceEnvelopeMoveErrors, ThrowOnError>({
    url: '/api/v1/finance/envelopes/{id}/reverse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * NBS and manual FX rates for a date range, newest first
 *
 * Requires finance.read. from and to are both required — the query has no
 * open-ended form, and an unset bound would answer «no rates» for a range
 * nobody asked about. rate_micro is units of currency per 1 EUR × 10^6.
 * 400 bad_request when from is after to; 422 validation when a bound is
 * the zero date 0001-01-01, which the reader refuses for the same reason
 * it refuses an unset one.
 *
 */
export const listFinanceFxRates = <ThrowOnError extends boolean = false>(options: Options<ListFinanceFxRatesData, ThrowOnError>) => (options.client ?? client).get<ListFinanceFxRatesResponses, ListFinanceFxRatesErrors, ThrowOnError>({ url: '/api/v1/finance/fx/rates', ...options });

/**
 * Set a rate by hand for one date and currency
 *
 * Requires finance.manage. The row is stored with source=manual and wins
 * over an NBS row for the same date and currency (core spec §6.3). EUR is
 * refused: §6.2 converts EUR by the identity rate without reading the
 * table at all. 422 validation for an unsupported currency or a
 * rate_micro that is not positive.
 *
 */
export const setFinanceFxRate = <ThrowOnError extends boolean = false>(options: Options<SetFinanceFxRateData, ThrowOnError>) => (options.client ?? client).put<SetFinanceFxRateResponses, SetFinanceFxRateErrors, ThrowOnError>({
    url: '/api/v1/finance/fx/rates/{date}/{currency}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recompute EUR equivalents over a date range
 *
 * Requires finance.manage. Re-resolves the rate for headers stamped
 * fx_source=nbs in OPEN months of [from, to], rewrites header and line
 * equivalents and creates, updates or deletes the fx_rounding line
 * (spec §6.3). Closed months are skipped, not refused. operation_id is
 * the client's idempotency key (spec §5.19).
 * 409 operation_conflict when the key was used for a different body;
 * 422 validation when from or to is missing or from is after to.
 *
 */
export const recomputeFinanceFx = <ThrowOnError extends boolean = false>(options: Options<RecomputeFinanceFxData, ThrowOnError>) => (options.client ?? client).post<RecomputeFinanceFxResponses, RecomputeFinanceFxErrors, ThrowOnError>({
    url: '/api/v1/finance/fx/recompute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finance settings
 *
 * Requires finance.read.
 */
export const getFinanceSettings = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetFinanceSettingsResponses, GetFinanceSettingsErrors, ThrowOnError>({ url: '/api/v1/finance/settings', ...options });

/**
 * Update finance settings
 *
 * Requires finance.manage. A field left out is left as it is.
 * import_cutoff and income_side_enabled are not settable here at all: the
 * first is fixed by the history import, the second is flipped only by
 * pms-cli finance cutover-income-side (slice 3).
 * 422 validation for an unknown channel key, an unknown account or
 * currency in a channel default, an unknown fx_source, or a business_tz
 * that is not a known IANA zone.
 *
 */
export const updateFinanceSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceSettingsData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceSettingsResponses, UpdateFinanceSettingsErrors, ThrowOnError>({
    url: '/api/v1/finance/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bank reconciliation journal, newest first
 *
 * Requires finance.read.
 */
export const listFinanceBankChecks = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceBankChecksData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceBankChecksResponses, ListFinanceBankChecksErrors, ThrowOnError>({ url: '/api/v1/finance/bank-checks', ...options });

/**
 * File the bank's balance for a pair on a date next to ours
 *
 * Requires finance.manage. Stores the bank's figure, the balance we
 * compute for the same account+currency+date, and the difference
 * (spec §5.14). Not an idempotent operation: a repeat files a second
 * reconciliation, which is what a second check IS. A pair with no
 * baseline on or before as_of is refused — the difference would only say
 * we never knew what the account started with.
 * 404 not_found for an unknown account;
 * 422 account_currency when the account does not hold the currency,
 * 422 validation when as_of is missing or the pair has no baseline.
 *
 */
export const createFinanceBankCheck = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceBankCheckData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceBankCheckResponses, CreateFinanceBankCheckErrors, ThrowOnError>({
    url: '/api/v1/finance/bank-checks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Months that have been touched, newest first
 *
 * Requires finance.read. A period row is created on the first write into
 * a month, so a month with no money in it has no row at all — this is the
 * history, not a calendar.
 *
 */
export const listFinancePeriods = <ThrowOnError extends boolean = false>(options?: Options<ListFinancePeriodsData, ThrowOnError>) => (options?.client ?? client).get<ListFinancePeriodsResponses, ListFinancePeriodsErrors, ThrowOnError>({ url: '/api/v1/finance/periods', ...options });

/**
 * Month status and snapshot
 *
 * Requires finance.read.
 */
export const getFinancePeriod = <ThrowOnError extends boolean = false>(options: Options<GetFinancePeriodData, ThrowOnError>) => (options.client ?? client).get<GetFinancePeriodResponses, GetFinancePeriodErrors, ThrowOnError>({ url: '/api/v1/finance/periods/{month}', ...options });

/**
 * What closing the month would freeze now, and what blocks it
 *
 * Requires finance.read. Read-only (envelopes spec §5.4): the snapshot
 * the close would write right now and every blocker, in one
 * repeatable-read read-only transaction; nothing is written or locked,
 * and the close re-checks everything under its own locks (advisory:
 * true). Besides the close's own codes: month_not_ended (the month is
 * still running), stays_pending (bookings changed since the last
 * recalculation — Close recalculates them first), stay_sync_failed
 * (bookings that could not be carried into the finance block — Close
 * retries them). A month without a period row is previewed as open.
 * 409 period_closed for a closed month (its snapshot is on GET
 * /finance/periods/{month}); 422 validation for a month that does not
 * exist ("2026-13").
 *
 */
export const getFinancePeriodPreview = <ThrowOnError extends boolean = false>(options: Options<GetFinancePeriodPreviewData, ThrowOnError>) => (options.client ?? client).get<GetFinancePeriodPreviewResponses, GetFinancePeriodPreviewErrors, ThrowOnError>({ url: '/api/v1/finance/periods/{month}/preview', ...options });

/**
 * Close the month with a frozen snapshot
 *
 * Requires finance.close. §9.1's precondition sweep is the finance.close
 * audit action.
 * 409 period_closed when the month is already closed;
 * 409 retry_close when a booking changed during the close sweep — retry;
 * 409 close_blocked when a §9.1 precondition fails, with the reasons in
 * `blockers`;
 * 409 month_not_ended when the month has not ended in the business
 * time zone yet (the current or a future month) — it can be closed
 * from the first day of the next month.
 * Optional body `{operation_id}` (§5.19): a retry with the same key
 * after a lost response replays the stored success (the period's
 * current row) instead of 409 period_closed; the same key on another
 * month → 409 operation_conflict. Without a body the close is not
 * idempotent (the pre-existing contract).
 *
 */
export const closeFinancePeriod = <ThrowOnError extends boolean = false>(options: Options<CloseFinancePeriodData, ThrowOnError>) => (options.client ?? client).post<CloseFinancePeriodResponses, CloseFinancePeriodErrors, ThrowOnError>({
    url: '/api/v1/finance/periods/{month}/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reopen the latest closed month (super_admin only)
 *
 * Requires finance.close. Also requires the super_admin role (§9.4) —
 * only the LATEST closed month can be reopened. operation_id is honoured
 * (§5.19): a retry with the same key replays the stored success instead
 * of 409 conflict.
 *
 */
export const reopenFinancePeriod = <ThrowOnError extends boolean = false>(options: Options<ReopenFinancePeriodData, ThrowOnError>) => (options.client ?? client).post<ReopenFinancePeriodResponses, ReopenFinancePeriodErrors, ThrowOnError>({
    url: '/api/v1/finance/periods/{month}/reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finance rules (recurring, per-stay, commission invoice)
 *
 * Requires finance.read. Disabled rules are left out unless
 * include_disabled=true.
 *
 */
export const listFinanceRules = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceRulesData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceRulesResponses, ListFinanceRulesErrors, ThrowOnError>({ url: '/api/v1/finance/rules', ...options });

/**
 * Create a finance rule
 *
 * Requires finance.manage. Created enabled, created_by = the actor.
 * params is opaque JSON here (schema FinanceRuleParams); the domain
 * (spec §7.4, ValidateRuleParams) strictly decodes it against the
 * shape its type requires and rejects an unknown key anywhere,
 * including nested under schedule, with 422 validation — never
 * silently ignored. 422 validation also covers: start_date before the
 * import cutoff, a scope/apartment_id mismatch, a parent_rule_id that
 * is not an apartment-scoped per_stay rule without a parent of its
 * own, and — for a biweekly schedule — an anchor date that does not
 * fall on the chosen weekday. This endpoint only writes the rule row;
 * it does not materialise finance_expected rows itself (a
 * worker/converger concern).
 *
 */
export const createFinanceRule = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceRuleData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceRuleResponses, CreateFinanceRuleErrors, ThrowOnError>({
    url: '/api/v1/finance/rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one finance rule
 *
 * Requires finance.read. 404 not_found for an unknown id.
 */
export const getFinanceRule = <ThrowOnError extends boolean = false>(options: Options<GetFinanceRuleData, ThrowOnError>) => (options.client ?? client).get<GetFinanceRuleResponses, GetFinanceRuleErrors, ThrowOnError>({ url: '/api/v1/finance/rules/{id}', ...options });

/**
 * Update a finance rule
 *
 * Requires finance.manage. type, scope, apartment_id, category_id and
 * parent_rule_id are immutable (a new category or a new parent is a
 * new rule) and start_date does not move once created; this endpoint
 * ignores those fields if sent and always returns the stored values.
 * enabled toggles pause/resume (spec §7.1/§7.2) without touching
 * generated_through or created_by. 404 not_found for an unknown id;
 * 422 validation for the same rules as create.
 *
 */
export const updateFinanceRule = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceRuleData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceRuleResponses, UpdateFinanceRuleErrors, ThrowOnError>({
    url: '/api/v1/finance/rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-walk every booking a per_stay rule could apply to
 *
 * Requires finance.manage. Company-scoped or non-per_stay rules are a
 * no-op: 200 with every counter at zero — nothing to walk. Does NOT
 * check enabled: a disabled apartment-scoped per_stay rule is rebuilt
 * too, because that walk is the only thing that cancels a dependent
 * rule's rows once its parent is paused (spec §7.2). This is
 * deliberate, not a gap to close.
 * A failure aborts the walk partway and marks every booking not yet
 * reached dirty for the next automatic pass — the response is never
 * 200 with partial counters on error.
 * 404 not_found for an unknown rule id, or (mid-walk) a booking gone
 * missing under a concurrent write;
 * 409 period_closed when a late or revived row has no open month left
 * to land in, 409 conflict on exhausted deadlock/serialization
 * retries or a row changed under a concurrent writer;
 * 422 validation when a per_stay rule's own parent linkage is broken.
 *
 */
export const rebuildFinanceRule = <ThrowOnError extends boolean = false>(options: Options<RebuildFinanceRuleData, ThrowOnError>) => (options.client ?? client).post<RebuildFinanceRuleResponses, RebuildFinanceRuleErrors, ThrowOnError>({ url: '/api/v1/finance/rules/{id}/rebuild', ...options });

/**
 * Expected payments awaiting confirmation (overdue, today, future)
 *
 * Requires finance.read. What the finblock's home screen shows: every
 * planned finance_expected row (spec §8.1) — slice 3 unions in
 * booking_payment_schedule and provider-fact rows into the same item
 * shape (plan contract §10) without changing it, so a client written
 * against this slice keeps working unchanged. Sorted overdue, then
 * today, then future, each bucket by due_date and then by a stable
 * tiebreaker, so a row is never skipped or repeated between pages.
 * total and items are read from one snapshot, so a page's total
 * always agrees with what it shows.
 *
 */
export const listFinanceQueue = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceQueueData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceQueueResponses, ListFinanceQueueErrors, ThrowOnError>({ url: '/api/v1/finance/queue', ...options });

/**
 * Expected payments scoped to a booking, an apartment or a rule
 *
 * Requires finance.read. Every finance_expected row for exactly ONE
 * of booking_id, apartment_id or rule_id (422 validation when zero or
 * more than one is given — an unscoped call would dump every
 * expectation the company has ever had, and no screen needs that):
 * the booking card's "Stay expenses" (spec §14), the apartment's
 * Finance tab, and a rule's own recent-occurrences list. status
 * further narrows the result; unlike the queue this also returns
 * confirmed/skipped/cancelled/draft rows, because a history view (not
 * a to-do list) is the point. No pagination — each of the three scopes
 * is bounded (one booking's or one rule's own rows, or one
 * apartment's), unlike the company-wide movements/queue feeds.
 *
 */
export const listFinanceExpected = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceExpectedData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceExpectedResponses, ListFinanceExpectedErrors, ThrowOnError>({ url: '/api/v1/finance/expected', ...options });

/**
 * Create a manual expected payment
 *
 * Requires finance.confirm. An operator-entered expectation without a
 * rule — an extra cleaning, an expected fine, a planned investor
 * payout (spec §8.3). origin is always 'operator'. period_month in a
 * closed month is refused (409 period_closed) — create it in the
 * currently open month with correction_for_month naming the closed
 * month instead. When correction_for_month is sent, it must itself
 * name a CLOSED month (422 validation otherwise).
 *
 */
export const createFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceExpectedData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceExpectedResponses, CreateFinanceExpectedErrors, ThrowOnError>({
    url: '/api/v1/finance/expected',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one expected payment
 *
 * Requires finance.read. 404 not_found for an unknown id.
 */
export const getFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<GetFinanceExpectedData, ThrowOnError>) => (options.client ?? client).get<GetFinanceExpectedResponses, GetFinanceExpectedErrors, ThrowOnError>({ url: '/api/v1/finance/expected/{id}', ...options });

/**
 * Skip an expected payment
 *
 * Requires finance.confirm. Skips dependents that are still planned
 * (spec §7.2). Idempotent by state: a second skip of an
 * already-skipped row (any reason) returns it unchanged rather than
 * erroring; 409 not_planned for any other non-planned status.
 *
 */
export const skipFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<SkipFinanceExpectedData, ThrowOnError>) => (options.client ?? client).post<SkipFinanceExpectedResponses, SkipFinanceExpectedErrors, ThrowOnError>({
    url: '/api/v1/finance/expected/{id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Split an expected payment into parts
 *
 * Requires finance.confirm. operation_id is required (spec §5.19):
 * the operation creates several rows, so a retried request must
 * replay the SAME parts rather than create a second set — same
 * operation_id with a different body is 409 operation_conflict.
 * parts must sum to exactly the row's amount_minor. The source row
 * becomes cancelled (split); each part carries split_of,
 * origin=operator and the source row's period_month unchanged.
 * Dependents (spec §7.2) split proportionally, the LAST part of each
 * dependent absorbing the rounding remainder so its shares still sum
 * to the dependent's own amount exactly.
 *
 */
export const splitFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<SplitFinanceExpectedData, ThrowOnError>) => (options.client ?? client).post<SplitFinanceExpectedResponses, SplitFinanceExpectedErrors, ThrowOnError>({
    url: '/api/v1/finance/expected/{id}/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move an expected payment's due date
 *
 * Requires finance.confirm. Sets moved_from_due_date to the prior
 * due_date; period_month never changes. The new due_date must fall
 * in an open month (409 period_closed otherwise). Idempotent by
 * state: moving to the SAME due_date the row already has is a
 * no-op, not an error; 409 not_planned for a non-planned row.
 *
 */
export const moveFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<MoveFinanceExpectedData, ThrowOnError>) => (options.client ?? client).post<MoveFinanceExpectedResponses, MoveFinanceExpectedErrors, ThrowOnError>({
    url: '/api/v1/finance/expected/{id}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an expected payment with one movement
 *
 * Requires finance.confirm. Creates one payment movement with a
 * settle line for this row (spec §8.2). amount_minor is the bank
 * amount, in currency; settled_minor is the same money in the row's
 * own currency (omitted → converted from the settle line by the NBS
 * rate of occurred_on). remainder is required only when the settled
 * amount is below the row's plan: restate re-prices the obligation
 * to what was actually paid; partial confirms the settled part and
 * leaves a new planned row (split_of) for the rest, with the same
 * period_month (Σ = the prior plan) — still-planned dependents split
 * proportionally between the confirmed share and the new row;
 * write_off confirms the settled part and skips the rest
 * (skip_reason = 'write_off'; still accepted, though no window
 * offers it any more). Paying the plan or more always
 * restates silently, no remainder needed (the 422 remainder_required
 * is for an amount below the plan only). The row closes at what was
 * actually paid (OH-205); without settled_minor, in another currency
 * than the row's, a payment within one minor unit of the plan
 * (forward in the payment currency, or back in the row's currency;
 * in any remainder mode) or, for remainder restate or none, within
 * 5% of the plan converted into the payment currency (the FX band)
 * settles the plan itself. An explicit settled_minor stands as
 * given: neither the tolerance nor the band touches it. A movement
 * that settles a planned row held in a currency other than the
 * movement's own books the whole EUR remainder on one fx_rounding
 * line under the "Курсовая разница" (fx_difference) article, never
 * on a fee or expense line. dependents co-settled in the SAME
 * payment (only when they share this row's counterparty) get their
 * own settle line, amount_minor there in the payment's currency, not
 * their own; they are refused (422 validation: "linked payments
 * follow this row's new plan — confirm them separately once it is
 * confirmed") when the row restates off its plan — remainder
 * restate, asked or implied by paying the plan or more, with a
 * settled amount other than the remaining plan — and go through when
 * the row closes at its plan (tolerance or band) or takes partial or
 * write_off below it; every OTHER still-planned dependent has its
 * plan recomputed from what was actually settled (percent_bp of the
 * new total, converted to its own currency, spec §7.2). A row whose
 * own period is closed, or that carries an explicit
 * correction_for_month, tags the movement with correction_for_month
 * so the closed month stays untouched and the open month shows it as
 * a late correction (§9.3).
 * An optional expect (OH-193 §4.5) turns a stale preview into 409
 * target_changed: the target's remaining or any rate of the
 * operation's snapshot differs from what the preview showed.
 *
 */
export const settleFinanceExpected = <ThrowOnError extends boolean = false>(options: Options<SettleFinanceExpectedData, ThrowOnError>) => (options.client ?? client).post<SettleFinanceExpectedResponses, SettleFinanceExpectedErrors, ThrowOnError>({
    url: '/api/v1/finance/expected/{id}/settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suggest the amounts and withheld lines of a settle (read-only)
 *
 * OH-193 (spec 2026-10-19 §4). Writes nothing and reserves nothing. For the
 * account, currency, date and 1..50 targets it returns each target's remaining
 * (in its own currency) and planned amount (in the account currency, by the same
 * conversion and tolerance the settle uses), the rate snapshot it used, suggested
 * withheld lines (the account's fee rule for incoming targets, the PayPal fee of a
 * capture projection converted into the account currency, or a batch shortfall),
 * the suggested bank amount and the difference. settleable=true means: sent back
 * unchanged WITH the returned expect, the settle succeeds as long as nothing
 * changed. Otherwise blockers say why. Requires finance.confirm.
 *
 */
export const previewFinanceSettle = <ThrowOnError extends boolean = false>(options: Options<PreviewFinanceSettleData, ThrowOnError>) => (options.client ?? client).post<PreviewFinanceSettleResponses, PreviewFinanceSettleErrors, ThrowOnError>({
    url: '/api/v1/finance/settle/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm several expected payments with one movement
 *
 * Requires finance.confirm. One bank payment closes N planned expected
 * payments under ONE movement equation (spec §8.4): Σ targets + Σ
 * income + Σ expense − Σ withheld = amount_minor, else 422 unbalanced
 * with the difference. Targets must share one direction; there are no
 * remainder modes (use POST .../expected/{id}/settle for a partial
 * payment). Each leg settles its target at what was paid for it. In
 * another currency than the target's, and without an explicit
 * settled_minor, a leg within one minor unit of the plan, or within 5%
 * of it in the account currency (OH-205), settles the plan itself.
 * Past that, an expected target closes at the amount paid, below its
 * plan as well as above it: its plan restates to that amount and its
 * still-planned percent dependents follow. A plain schedule row is
 * guest money and settles in FULL only: a leg below its plan is
 * refused (422 validation), never narrowed to a partial; a PSP-fact
 * projection settles on the fact's own amount only (422
 * psp_fact_indivisible). amount_minor per
 * target is in the payment's currency; settled_minor (optional) is in
 * the target's own currency, default converted by the NBS rate of
 * occurred_on — targets may be in different currencies. Extra
 * income/expense/withheld lines land on the SAME header as the settle
 * lines, not separate payments. Once any target is tied to an airbnb
 * or booking.com booking, a withheld line under "Комиссия
 * (платформа)" is refused for the whole batch — that commission is
 * derived from the booking (§11) or arrives only as the monthly
 * invoice (§7.3), so a withheld line here would double count it.
 * An optional expect (OH-193 §4.5) turns a stale preview into 409
 * target_changed: a target's remaining or any rate of the operation's
 * snapshot differs from what the preview showed; it is checked before
 * any amount-dependent refusal.
 *
 */
export const settleFinanceBatch = <ThrowOnError extends boolean = false>(options: Options<SettleFinanceBatchData, ThrowOnError>) => (options.client ?? client).post<SettleFinanceBatchResponses, SettleFinanceBatchErrors, ThrowOnError>({
    url: '/api/v1/finance/settle-batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm a booking schedule row against a finance movement
 *
 * §8.2/§5.16: capture/refund rows are projections of a PSP fact — settled for the full fact amount (remainder → 422 psp_fact_indivisible), fees as withheld lines; payout/vcc_charge/manual rows are their own target and accept remainder restate|partial|write_off, and the at-plan rule, the FX band and the fx_difference routing of the EUR remainder are those of settleFinanceExpected (OH-205). Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover. An optional expect (OH-193 §4.5) turns a stale preview into 409 target_changed (the row's remaining or a rate of the operation's snapshot differs from what the preview showed).
 */
export const settleFinanceScheduleEntry = <ThrowOnError extends boolean = false>(options: Options<SettleFinanceScheduleEntryData, ThrowOnError>) => (options.client ?? client).post<SettleFinanceScheduleEntryResponses, SettleFinanceScheduleEntryErrors, ThrowOnError>({
    url: '/api/v1/finance/schedule-entries/{id}/settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Settle a captured payment with no schedule row able to settle it (third queue source)
 *
 * §10.4: a PSP fact with no schedule row able to settle it — no booking at all, or an owner whose only row cannot (OH-183 item 7) — settled on its full captured amount only. Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const settleFinanceProviderPayment = <ThrowOnError extends boolean = false>(options: Options<SettleFinanceProviderPaymentData, ThrowOnError>) => (options.client ?? client).post<SettleFinanceProviderPaymentResponses, SettleFinanceProviderPaymentErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/payments/{id}/settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a provider payment as resolved without money
 *
 * §10.4: "разобрано без денег" — takes the fact out of the queue without a movement. Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const resolveFinanceProviderPayment = <ThrowOnError extends boolean = false>(options: Options<ResolveFinanceProviderPaymentData, ThrowOnError>) => (options.client ?? client).post<ResolveFinanceProviderPaymentResponses, ResolveFinanceProviderPaymentErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/payments/{id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo a resolution
 *
 * Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const unresolveFinanceProviderPayment = <ThrowOnError extends boolean = false>(options: Options<UnresolveFinanceProviderPaymentData, ThrowOnError>) => (options.client ?? client).post<UnresolveFinanceProviderPaymentResponses, UnresolveFinanceProviderPaymentErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/payments/{id}/unresolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Settle an executed refund obligation with no schedule row able to settle it
 *
 * §10.4: a refund fact with no schedule row able to settle it — no booking at all, or an owner whose only row cannot (OH-183 item 7) — settled on its full executed amount only. Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const settleFinanceProviderRefund = <ThrowOnError extends boolean = false>(options: Options<SettleFinanceProviderRefundData, ThrowOnError>) => (options.client ?? client).post<SettleFinanceProviderRefundResponses, SettleFinanceProviderRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/refunds/{id}/settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a refund fact as resolved without money
 *
 * Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const resolveFinanceProviderRefund = <ThrowOnError extends boolean = false>(options: Options<ResolveFinanceProviderRefundData, ThrowOnError>) => (options.client ?? client).post<ResolveFinanceProviderRefundResponses, ResolveFinanceProviderRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/refunds/{id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo a refund resolution
 *
 * Requires finance.confirm. Refused with 409 income_side_disabled before the slice-3 cutover.
 */
export const unresolveFinanceProviderRefund = <ThrowOnError extends boolean = false>(options: Options<UnresolveFinanceProviderRefundData, ThrowOnError>) => (options.client ?? client).post<UnresolveFinanceProviderRefundResponses, UnresolveFinanceProviderRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/provider/refunds/{id}/unresolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refund obligations for a payment or booking, with their attempts
 *
 * Requires finance.read. §5.15: refund obligations (payment_refunds) scoped by at least one of payment_id/booking_id (both may be set together — a narrowing pair, not ListFinanceExpected's own exactly-one scope). Each obligation carries its own attempts (refund_id = the obligation's own id) — an unpaired attempt (refund_id IS NULL) is never listed here; see GET /finance/provider-events' own unpaired section for those (the SPA's attach flow reads unpaired attempts from there and offers this endpoint's obligations as the target to attach one onto). Ordered created_at, id.
 */
export const listFinanceRefunds = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceRefundsData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceRefundsResponses, ListFinanceRefundsErrors, ThrowOnError>({ url: '/api/v1/finance/refunds', ...options });

/**
 * Write a refund obligation off (unreturned money becomes revenue)
 *
 * Requires finance.confirm. §5.15.
 */
export const writeOffFinanceRefund = <ThrowOnError extends boolean = false>(options: Options<WriteOffFinanceRefundData, ThrowOnError>) => (options.client ?? client).post<WriteOffFinanceRefundResponses, WriteOffFinanceRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/refunds/{id}/write-off',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Split an open refund obligation into parts
 *
 * Requires finance.confirm. §5.15.
 */
export const splitFinanceRefund = <ThrowOnError extends boolean = false>(options: Options<SplitFinanceRefundData, ThrowOnError>) => (options.client ?? client).post<SplitFinanceRefundResponses, SplitFinanceRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/refunds/{id}/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach an unpaired completed provider refund to this obligation
 *
 * Requires finance.confirm. §5.15.
 */
export const attachFinanceRefund = <ThrowOnError extends boolean = false>(options: Options<AttachFinanceRefundData, ThrowOnError>) => (options.client ?? client).post<AttachFinanceRefundResponses, AttachFinanceRefundErrors, ThrowOnError>({
    url: '/api/v1/finance/refunds/{id}/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verified re-read of the provider resource for this attempt
 *
 * Requires finance.confirm. §5.15.
 */
export const matchFinanceRefundAttempt = <ThrowOnError extends boolean = false>(options: Options<MatchFinanceRefundAttemptData, ThrowOnError>) => (options.client ?? client).post<MatchFinanceRefundAttemptResponses, MatchFinanceRefundAttemptErrors, ThrowOnError>({
    url: '/api/v1/finance/refund-attempts/{id}/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Declare an unknown attempt past its deadline as never executed
 *
 * Requires finance.confirm. §5.15.
 */
export const abandonFinanceRefundAttempt = <ThrowOnError extends boolean = false>(options: Options<AbandonFinanceRefundAttemptData, ThrowOnError>) => (options.client ?? client).post<AbandonFinanceRefundAttemptResponses, AbandonFinanceRefundAttemptErrors, ThrowOnError>({
    url: '/api/v1/finance/refund-attempts/{id}/abandon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provider money with no schedule row able to settle it, unpaired events, contradictions, stale attempts, anomalies
 *
 * Requires finance.read. §10.4. `processed` selects which PSP facts
 * the provider_queue section lists: `none` (default) — the
 * unprocessed third-source facts (the queue); `resolved` — the same
 * facts already marked «разобрано» (processed = resolved, with their
 * resolution), so a mistaken Resolve can be undone with Unresolve.
 * With `processed=resolved` only provider_queue is returned — the
 * attempt and anomaly sections carry no processed state and come back
 * empty; `total` counts what is returned. Settled facts are never
 * listed here (their way back is reversing the movement).
 *
 */
export const listFinanceProviderEvents = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceProviderEventsData, ThrowOnError>) => (options?.client ?? client).get<ListFinanceProviderEventsResponses, ListFinanceProviderEventsErrors, ThrowOnError>({ url: '/api/v1/finance/provider-events', ...options });

/**
 * Presigned PUT for a receipt (private bucket)
 *
 * Requires finance.submit. finance.confirm also grants entry, and
 * widens what a request may target: exactly one of expected_id,
 * movement_id, submission_id must be set, a finance.submit-only actor
 * may only target their own submission (expected_id/movement_id need
 * finance.confirm), and a finance.confirm actor may target any of the
 * three. mime is checked against a fixed allowlist here
 * (jpeg/png/webp/pdf, ≤ 15728640 bytes) and again against the file's
 * ACTUAL bytes at register time — this endpoint never trusts the
 * declared mime beyond the allowlist check.
 *
 */
export const issueFinanceAttachmentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<IssueFinanceAttachmentUploadUrlData, ThrowOnError>) => (options.client ?? client).post<IssueFinanceAttachmentUploadUrlResponses, IssueFinanceAttachmentUploadUrlErrors, ThrowOnError>({
    url: '/api/v1/finance/attachments/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify and register an uploaded receipt
 *
 * Requires finance.submit. finance.confirm also grants entry; the
 * caller must be the uploader unless it holds finance.confirm. Reads
 * the object's actual
 * header bytes back from the private bucket and checks the file
 * signature against the mime declared at upload-url time (spec §14) —
 * a mismatch, an unreadable object, or a size outside 1..15728640
 * bytes deletes the object and answers 422 validation; the row is
 * left unregistered for the GC (spec §5.11). Idempotent: a second call
 * on an already-registered id returns it unchanged rather than
 * re-verifying.
 *
 */
export const registerFinanceAttachment = <ThrowOnError extends boolean = false>(options: Options<RegisterFinanceAttachmentData, ThrowOnError>) => (options.client ?? client).post<RegisterFinanceAttachmentResponses, RegisterFinanceAttachmentErrors, ThrowOnError>({
    url: '/api/v1/finance/attachments/{id}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Presigned GET for a receipt (5 minutes)
 *
 * Requires finance.read. finance.confirm and finance.submit also grant
 * entry; without read or confirm the caller must OWN the attachment —
 * the uploader, or the submitter of the submission it is attached to
 * (spec §16 item 12: finance.submit sees and creates only its own —
 * never a stranger's, even by guessed id). 404 for an id that does not
 * exist OR is not yet registered: there is nothing to download at
 * either.
 *
 */
export const getFinanceAttachmentDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetFinanceAttachmentDownloadUrlData, ThrowOnError>) => (options.client ?? client).get<GetFinanceAttachmentDownloadUrlResponses, GetFinanceAttachmentDownloadUrlErrors, ThrowOnError>({ url: '/api/v1/finance/attachments/{id}/download-url', ...options });

/**
 * Reference data for the phone submission form
 *
 * Requires finance.submit. Everything the phone form needs to render —
 * expense categories, active apartments, counterparties — each by id
 * plus a name/code/title only (spec §8.3, §21, §16 item 12): never an
 * amount, a balance, or anyone else's data. counterparties is scoped
 * to the caller's own past submissions, not the company's whole list
 * (invariant §16 item 12) — empty for a submitter with no submission
 * history yet.
 *
 */
export const getFinanceSubmissionRefs = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceSubmissionRefsData, ThrowOnError>) => (options?.client ?? client).get<GetFinanceSubmissionRefsResponses, GetFinanceSubmissionRefsErrors, ThrowOnError>({ url: '/api/v1/finance/submissions/refs', ...options });

/**
 * Open a phone expense submission draft
 *
 * Requires finance.submit. A cleaner or handyman photographs a
 * receipt, picks a category and (optionally) an apartment and a
 * counterparty, and opens a draft (spec §8.3) — direction is always
 * 'out', origin is always 'submission', submitted_by is the caller.
 * The draft is visible and editable only by its own author until it
 * is sent (POST .../{id}/send). A category that is not an expense is
 * refused; one that requires a counterparty is refused only when
 * counterparty_id is absent.
 *
 */
export const createFinanceSubmission = <ThrowOnError extends boolean = false>(options: Options<CreateFinanceSubmissionData, ThrowOnError>) => (options.client ?? client).post<CreateFinanceSubmissionResponses, CreateFinanceSubmissionErrors, ThrowOnError>({
    url: '/api/v1/finance/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit a submission draft
 *
 * Requires finance.submit. The caller must be the submission's own
 * author (403 otherwise); finance.confirm also grants entry, and
 * bypasses that ownership check the same way — but not the status
 * one: this endpoint only ever edits a DRAFT, whoever is asking (409
 * not_planned once the row has been sent — spec §8.3, "черновик
 * правит только автор до отправки"; a sent submission is edited
 * through the ordinary expected/settle endpoints instead, not a
 * second door back into this one).
 *
 */
export const updateFinanceSubmission = <ThrowOnError extends boolean = false>(options: Options<UpdateFinanceSubmissionData, ThrowOnError>) => (options.client ?? client).patch<UpdateFinanceSubmissionResponses, UpdateFinanceSubmissionErrors, ThrowOnError>({
    url: '/api/v1/finance/submissions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a submission draft to finance
 *
 * Requires finance.submit. The caller must be the submission's own
 * author (403 otherwise); finance.confirm also grants entry.
 * Moves a draft into the ordinary queue: planned, due_date=today,
 * period_month=month(today) (spec §8.3) — refused if today's month is
 * closed (409 period_closed). Idempotent by state: sending an
 * already-sent submission a second time returns it unchanged rather
 * than erroring; 409 not_planned for any other non-draft status.
 *
 */
export const sendFinanceSubmission = <ThrowOnError extends boolean = false>(options: Options<SendFinanceSubmissionData, ThrowOnError>) => (options.client ?? client).post<SendFinanceSubmissionResponses, SendFinanceSubmissionErrors, ThrowOnError>({ url: '/api/v1/finance/submissions/{id}/send', ...options });

/**
 * My own phone submissions, draft or sent
 *
 * Requires finance.submit. Every submission the caller has authored —
 * never anyone else's (spec §16 item 12) — newest first, draft or
 * sent, with its current status (and, once acted on, its skip reason)
 * so the author can see what happened to it.
 *
 */
export const listMyFinanceSubmissions = <ThrowOnError extends boolean = false>(options?: Options<ListMyFinanceSubmissionsData, ThrowOnError>) => (options?.client ?? client).get<ListMyFinanceSubmissionsResponses, ListMyFinanceSubmissionsErrors, ThrowOnError>({ url: '/api/v1/finance/submissions/mine', ...options });
